import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Avatar,
  Typography,
  Box,
  Grid,
  Chip,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  IconButton,
  Divider,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Pagination,
  Stack,
  tooltipClasses,
  Collapse,
  Paper,
  Menu,
  MenuItem,
  Checkbox,
} from "@mui/material";
import {
  Checklist,
  Close,
  Language,
  PhoneAndroid,
  PictureAsPdf,
  Subject as SubjectIcon,
  WorkHistory,
  WorkHistoryOutlined,
  Work as WorkIcon,
  WorkspacePremium,
  Email as EmailIcon,
  History as HistoryIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Check,
  MoreVert,
  Block as BlockIcon,
  Add as AddIcon,
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SplitButton from "./SplitButton";
import EmailHistory from "../Emailing/EmailHistory";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { styled } from "@mui/material/styles";
import { COLORS } from "colors/color";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useTranslation } from "react-i18next";
import {
  GraduationCap,
  LanguagesIcon,
  MapPinned,
  Wrench,
  Leaf,
  Mail,
  Code,
  Briefcase,
  Award,
  Book,
  FileText,
  Heart,
} from "lucide-react";
import axios from "axios";
import FilterDialog from "components/Dialog/FilterDialog";
import filterIcon from "../../assets/img/filter_icon.svg";
import { Navigate, useNavigate } from "react-router-dom";
import dropdown_icon from "../../assets/img/dropdown_icon.svg";

import lightbulb from "../../assets/img/lightbulb.svg";
import linkedin_icon from "../../assets/img/linkedin_icon_small.svg";
import ring_icon from "../../assets/img/ring_icon.svg";
import file_icon from "../../assets/img/file_icon.svg";
import open_book from "../../assets/img/open_book.svg";
import expand_icon from "../../assets/img/expand_icon.svg";
import mail_icon from "../../assets/img/mail_icon.svg";
import searchIcon from "../../assets/img/search_icon_grey.svg";
import colors from "colors/color";
import { useContext } from "react";
import { SnackbarContext } from "../../components/snackBar/SnackbarContext";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  TextField,
  CircularProgress,
  Select,
  InputAdornment,
  FormControl,
  InputLabel,
} from "@mui/material";
import { List as MuiList, ListItemButton } from "@mui/material";
import { ControlledBoard } from "./board";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewKanbanIcon from "@mui/icons-material/ViewWeek";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { PostSearchBar } from "components/searchBars/SearchBars";
import { Filter } from "lucide-react";
// import filterIcon from "../../assets/img/filter_icon.svg";

const StyledCard = styled(Card)(({ theme }) => ({
  width: "100%",
  borderRadius: theme.spacing(4),
  boxShadow: "none",
  marginBottom: theme.spacing(0),
  overflow: "hidden",
  position: "relative",
  // transition: "all 0.3s ease-in-out",
  background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
  // "&:hover": {
  //   transform: "translateY(-10px)",
  //   boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
  // },
  [theme.breakpoints.down("xl")]: {
    borderRadius: theme.spacing(3.5),
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("lg")]: {
    borderRadius: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("md")]: {
    borderRadius: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("xs")]: {
    borderRadius: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    borderRadius: theme.spacing(5),
    marginBottom: theme.spacing(7),
  },
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  },
}));

const StyledDialogContent = styled(DialogContent)({
  padding: 0,
});

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: "Poppins",
    borderColor: "#00000033",
    backgroundColor: "#fff",
    transition: "border-color 0.4s ease, box-shadow 0.4s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
  },
}));

const ScoreTriangle = styled("div")(({ theme, score }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  borderStyle: "solid",
  borderWidth: "0 200px 200px 0",
  [theme.breakpoints.down("xl")]: {
    borderWidth: "0 180px 180px 0",
  },
  [theme.breakpoints.down("lg")]: {
    borderWidth: "0 160px 160px 0",
  },
  [theme.breakpoints.down("md")]: {
    borderWidth: "0 140px 140px 0",
  },
  [theme.breakpoints.down("sm")]: {
    borderWidth: "0 120px 120px 0",
  },
  [theme.breakpoints.down("xs")]: {
    borderWidth: "0 100px 100px 0",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    borderWidth: "0 80px 80px 0",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    borderWidth: "0 220px 220px 0",
  },
  borderColor: `transparent ${getScoreColor(score)} transparent transparent`,
  zIndex: 1,
}));

const ScoreContent = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  right: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  zIndex: 3, // Increased z-index to ensure it's above card content
  [theme.breakpoints.down("xl")]: {
    top: "18px",
    right: "18px",
  },
  [theme.breakpoints.down("lg")]: {
    top: "16px",
    right: "16px",
  },
  [theme.breakpoints.down("md")]: {
    top: "14px",
    right: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    top: "12px",
    right: "12px",
  },
  [theme.breakpoints.down("xs")]: {
    top: "10px",
    right: "10px",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    top: "8px",
    right: "8px",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    top: "25px",
    right: "25px",
  },
  // Ensure proper alignment on all screen sizes
  "& > *": {
    textAlign: "right",
  },
  // Add responsive max-width to prevent overflow
  maxWidth: {
    xs: "80px",
    sm: "100px",
    md: "120px",
    lg: "140px",
    xl: "160px",
  },
}));

const InfoIcon = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "-10px",
  right: "-10px",
  padding: "4px",
  color: "#fff",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  [theme.breakpoints.down("xl")]: {
    top: "-9px",
    right: "-9px",
    padding: "3.5px",
  },
  [theme.breakpoints.down("lg")]: {
    top: "-8px",
    right: "-8px",
    padding: "3px",
  },
  [theme.breakpoints.down("md")]: {
    top: "-7px",
    right: "-7px",
    padding: "2.5px",
  },
  [theme.breakpoints.down("sm")]: {
    top: "-6px",
    right: "-6px",
    padding: "2px",
  },
  [theme.breakpoints.down("xs")]: {
    top: "-5px",
    right: "-5px",
    padding: "1.5px",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    top: "-4px",
    right: "-4px",
    padding: "1px",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    top: "-12px",
    right: "-12px",
    padding: "5px",
  },
  zIndex: 4, // Increased z-index to ensure it's above all other elements
}));

const ScoreText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: "#fff",
  fontSize: "3rem",
  lineHeight: 1,
  [theme.breakpoints.down("xl")]: {
    fontSize: "2.8rem",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "2.6rem",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "2.4rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: "1.8rem",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    fontSize: "1.5rem",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    fontSize: "3.5rem",
  },
  zIndex: 2,
  // Prevent text overflow
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%",
}));
const ScoreComment = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: "#fff",
  textAlign: "right",
  maxWidth: "180px",
  fontSize: "1rem",
  [theme.breakpoints.down("xl")]: {
    fontSize: "0.95rem",
    maxWidth: "170px",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "0.9rem",
    maxWidth: "160px",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "0.875rem",
    maxWidth: "150px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
    maxWidth: "120px",
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: "0.75rem",
    maxWidth: "100px",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    fontSize: "0.7rem",
    maxWidth: "94px",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    fontSize: "1.1rem",
    maxWidth: "200px",
  },
  zIndex: 2,
  // Prevent text overflow
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));
const InfoChipContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
  [theme.breakpoints.down("xl")]: {
    gap: theme.spacing(0.9),
  },
  [theme.breakpoints.down("lg")]: {
    gap: theme.spacing(0.8),
  },
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(0.7),
  },
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(0.5),
  },
  [theme.breakpoints.down("xs")]: {
    gap: theme.spacing(0.4),
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    gap: theme.spacing(0.3),
    marginTop: theme.spacing(0.5),
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    gap: theme.spacing(1.2),
  },
}));
const ResponsiveAvatar = styled(Avatar)(({ theme }) => ({
  width: 90,
  height: 90,
  marginRight: theme.spacing(2),
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  [theme.breakpoints.down("xl")]: {
    width: 85,
    height: 85,
    marginRight: theme.spacing(1.8),
  },
  [theme.breakpoints.down("lg")]: {
    width: 80,
    height: 80,
    marginRight: theme.spacing(1.6),
  },
  [theme.breakpoints.down("md")]: {
    width: 75,
    height: 75,
    marginRight: theme.spacing(1.4),
  },
  [theme.breakpoints.down("sm")]: {
    width: 60,
    height: 60,
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.down("xs")]: {
    width: 50,
    height: 50,
    marginRight: theme.spacing(0.8),
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    width: 45,
    height: 45,
    marginRight: theme.spacing(0.5),
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    width: 100,
    height: 100,
    marginRight: theme.spacing(2.5),
  },
  backgroundColor: `${COLORS.button_color}30`,
  backdropFilter: "blur(4px)",
}));
const InfoChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  fontWeight: 500,
  borderRadius: "20px",
  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  "& .MuiChip-icon": {
    color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("xl")]: {
    margin: theme.spacing(0.45),
    borderRadius: "18px",
  },
  [theme.breakpoints.down("lg")]: {
    margin: theme.spacing(0.4),
    borderRadius: "16px",
  },
  [theme.breakpoints.down("md")]: {
    margin: theme.spacing(0.35),
    borderRadius: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(0.25),
    borderRadius: "12px",
  },
  [theme.breakpoints.down("xs")]: {
    margin: theme.spacing(0.2),
    borderRadius: "10px",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    margin: theme.spacing(0.15),
    borderRadius: "8px",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    margin: theme.spacing(0.6),
    borderRadius: "22px",
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: "25px",
  padding: theme.spacing(1.5, 3),
  fontWeight: 600,
  textTransform: "none",
  transition: "all 0.3s ease",
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
  },
  [theme.breakpoints.down("xl")]: {
    padding: theme.spacing(1.4, 2.8),
    borderRadius: "23px",
  },
  [theme.breakpoints.down("lg")]: {
    padding: theme.spacing(1.3, 2.6),
    borderRadius: "21px",
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(1.2, 2.4),
    borderRadius: "19px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1, 2),
    borderRadius: "17px",
  },
  [theme.breakpoints.down("xs")]: {
    padding: theme.spacing(0.8, 1.6),
    borderRadius: "15px",
  },
  // Handle extra small screens
  "@media (max-width: 400px)": {
    padding: theme.spacing(0.6, 1.2),
    borderRadius: "13px",
  },
  // Handle very large screens
  "@media (min-width: 1920px)": {
    padding: theme.spacing(1.7, 3.5),
    borderRadius: "27px",
  },
}));
const getScoreColor = (score) => {
  if (score >= 75) return "#4caf50";
  if (score >= 45) return "#0befef";
  return "#f9510e";
};

// Helper function to get score background
const getScoreBackground = (score) => {
  if (score >= 75) return "linear-gradient(135deg, #10B981 0%, #059669 100%)";
  if (score >= 45) return "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)";
  return "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)";
};

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "#333",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    fontSize: 13,
    fontWeight: 400,
    borderRadius: "12px",
    padding: "10px 14px",
    maxWidth: 260,
    lineHeight: 1.4,
    fontFamily: "Poppins, sans-serif",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#ffffff",
  },
}));

const StyledTypography = styled(Typography)(() => ({
  fontFamily: "Poppins",
}));

const CandidateCard = React.forwardRef(({
  candidate,
  resume_path,
  coverLetter,
  steps,
  post_id,
  isSelected,
  onSelect,
  onCandidatesUpdate,
  onClick,
  isHighlighted,
  onContact,
}, ref) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const [age, setAge] = useState(0);
  const [showSkillsModal, setShowSkillsModal] = useState(false);
  const [showEducationModal, setShowEducationModal] = useState(false);
  const [showCertificatesModal, setShowCertificatesModal] = useState(false);
  const [showExperienceModal, setShowExperienceModal] = useState(false);
  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState(false);

  const [showAllSkills, setShowAllSkills] = useState(false);
  const [showAllLanguages, setShowAllLanguages] = useState(false);
  const [showAllEducation, setShowAllEducation] = useState(false);
  const [showAllCertificates, setShowAllCertificates] = useState(false);
  const [showAllExperience, setShowAllExperience] = useState(false);

  // State for unified resume dialog
  const [showUnifiedResumeDialog, setShowUnifiedResumeDialog] = useState(false);
  const [activeResumeSection, setActiveResumeSection] = useState("");
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [quizResponses, setQuizResponses] = useState(null);
  const [loadingQuiz, setLoadingQuiz] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;

  // State for collapsible card
  const [expanded, setExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const [cardOverflow, setCardOverflow] = useState("hidden");

  // useEffect(() => {
  //   console.log("candidates:::", candidate);
  // }, []);

  useEffect(() => {
    console.log("StepsSteps:", steps);
  }, []);

  useEffect(() => {
    console.log("candidate:::", candidate);
    if (!candidate || !candidate.candidate?.date_of_birth) return;

    const calculateAge = (dateOfBirth) => {
      const today = new Date();
      const birthDate = new Date(dateOfBirth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    };

    const age = calculateAge(candidate.candidate.date_of_birth);
    setAge(age);
  }, [candidate]);

  // Scroll to the active section when unified dialog opens
  useEffect(() => {
    if (showUnifiedResumeDialog) {
      if (activeResumeSection) {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          const element = document.getElementById(
            `${activeResumeSection}-section`
          );
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }

      // Fetch quiz responses when dialog opens
      const fetchQuiz = async () => {
        setLoadingQuiz(true);
        const data = await get_candidate_responses();
        setQuizResponses(data?.quiz_responses);
        setLoadingQuiz(false);
        console.log("Quiz Responses:", data?.quiz_responses);
      };

      if (!quizResponses) {
        fetchQuiz();
      }
    }
  }, [showUnifiedResumeDialog, activeResumeSection]);

  const searchProfile = async (name) => {
    try {
      const payload = {
        name: name,
      };
      const response = await axios.post(
        `${apiUrl}authentication/linkedin/search-profile/`,
        payload
      );
      const url = response.data.search_url;
      console.log("LinkedIn Profile URL:", url);

      if (url) {
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
          newWindow.focus(); // This will attempt to bring the new tab into focus
        }
      }

      return url;
    } catch (error) {
      console.error("Search profile failed:", error);
      alert(error.response?.data?.detail || "Failed to search profile");
      throw error;
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!candidate) return null;

  const get_candidate_responses = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}candidates/get-quiz-responses/${candidate.candidate.id}/${post_id}/`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching quiz responses:", error);
      return null;
    }
  };
  const handleResumeClick = async () => {
    console.log(resume_path);
    if (!resume_path) {
      alert(t("resume_not_available")); // Translated text
      return;
    }

    // Ensure the resume_path uses forward slashes
    const normalizedResumePath = resume_path.replace(/\\/g, "/");
    const fileURL = `${apiUrl}media/${normalizedResumePath}`;

    try {
      const response = await fetch(`${apiUrl}ai/search_resume/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ resume_url: fileURL }),
      });

      const contentType = response.headers.get("content-type");

      if (response.ok) {
        if (contentType && contentType.includes("application/pdf")) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        } else {
          console.log(t("unexpected_response")); // Translated text
        }
      } else {
        if (contentType && contentType.includes("text/html")) {
          const htmlContent = await response.text();
          const newWindow = window.open();
          newWindow.document.write(htmlContent);
          newWindow.document.close();
        } else {
          const data = await response.json();
          console.log(data.message);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getScoreComment = (score) => {
    if (score >= 75) return t("excellent_match"); // Translated text
    if (score >= 45) return t("good_potential"); // Translated text
    return t("consider_carefully"); // Translated text
  };
  const handleLetterClick = async () => {
    console.log(coverLetter);
    if (!coverLetter) {
      alert(t("cover_letter_not_available")); // Translated text
      return;
    }

    const normalizedResumePath = coverLetter.replace(/\\/g, "/");
    const fileURL = `${apiUrl}media/${normalizedResumePath}`;

    try {
      const response = await fetch(`${apiUrl}ai/search_resume/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ resume_url: fileURL }),
      });

      const contentType = response.headers.get("content-type");

      if (response.ok) {
        if (contentType && contentType.includes("application/pdf")) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        } else {
          console.log(t("unexpected_response")); // Translated text
        }
      } else {
        if (contentType && contentType.includes("text/html")) {
          const htmlContent = await response.text();
          const newWindow = window.open();
          newWindow.document.write(htmlContent);
          newWindow.document.close();
        } else {
          const data = await response.json();
          console.log(data.message);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const processLanguages = (languageData) => {
    if (!languageData) return [];

    // If it's already an array
    if (Array.isArray(languageData)) {
      return languageData;
    }

    // If it's a string
    if (typeof languageData === "string") {
      return languageData
        .replace(/^\[|\]$/g, "")
        .split(",")
        .map((lang) => lang.trim().replace(/^['"]|['"]$/g, ""));
    }

    return [];
  };
  const processEducation = (educationData) => {
    if (!educationData) return [];

    // If it's already an array of objects
    if (Array.isArray(educationData)) {
      return educationData;
    }

    // If it's a string, try to parse it
    if (typeof educationData === "string") {
      try {
        const parsed = JSON.parse(educationData);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        // Fallback for old format
        return educationData
          .replace(/^\[|\]$/g, "")
          .split(",")
          .map((lang) => ({
            text: lang.trim().replace(/^['"]|['"]$/g, ""),
            date_range: "",
          }));
      }
    }

    return [];
  };
  const processExperiences = (experienceData) => {
    if (!experienceData) return [];

    // If it's already an array of objects
    if (Array.isArray(experienceData)) {
      return experienceData;
    }

    // If experienceData is a string, try to parse it
    if (typeof experienceData === "string") {
      try {
        const parsed = JSON.parse(experienceData);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error("Error parsing experiences:", error);
        // Fallback: return an array with a single item
        return [
          {
            position: "Unknown Position",
            company: "Unknown Company",
            date_range: null,
            responsibilities: [experienceData],
          },
        ];
      }
    }

    return [];
  };

  const openSkillsModal = () => {
    setActiveResumeSection("skills");
    setShowUnifiedResumeDialog(true);
  };

  const closeSkillsModal = () => {
    setShowSkillsModal(false);
  };

  const openEducationModal = () => {
    setActiveResumeSection("education");
    setShowUnifiedResumeDialog(true);
  };

  const closeEducationModal = () => {
    setShowEducationModal(false);
  };

  const openLanguagesModal = () => {
    setActiveResumeSection("languages");
    setShowUnifiedResumeDialog(true);
  };

  const closeLanguagesModal = () => {
    setShowAllLanguages(false);
  };

  const openCertificatesModal = () => {
    setActiveResumeSection("certificates");
    setShowUnifiedResumeDialog(true);
  };

  const closeCertificatesModal = () => {
    setShowCertificatesModal(false);
  };

  const openExperienceModal = () => {
    setActiveResumeSection("experience");
    setShowUnifiedResumeDialog(true);
  };

  const closeExperienceModal = () => {
    setShowExperienceModal(false);
  };

  const closeUnifiedResumeDialog = () => {
    setShowUnifiedResumeDialog(false);
    setActiveResumeSection("");
  };

  const getUserIdFromAccessToken = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return null;
    try {
      const base64Url = accessToken.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload).user_id;
    } catch (error) {
      console.error("Failed to decode token:", error);
      return null;
    }
  };


  const handleEmailClickContact = (event) => {
    event.preventDefault();
    if (onContact) onContact(candidate);
  };

  const handleEmailHistoryClick = (event) => {
    event.preventDefault();
    setIsEmailHistoryOpen(true);
  };

  return (
    <>
      <Box sx={{ maxWidth: 1200, width: "100%", position: "relative" }}>
        {/* FIXED OVERLAY - Always visible during transition */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 3,
            }}
          >
            {/* Fixed Name - Left */}
            <Typography
              sx={{
                fontSize: 17,
                fontFamily: "Poppins",
                fontWeight: 700,
                pointerEvents: "auto",
              }}
            >
              {/* {candidate.candidate?.first_name || ""}{" "}
              {candidate.candidate?.last_name || ""} */}
            </Typography>

            {/* Fixed Score and Dropdown - Right */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                pointerEvents: "auto",
              }}
            >
              {/* AI Score Chip */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  zIndex: 1,
                }}
              >
                <Chip
                  variant="outlined"
                  label={
                    <Box display="flex" alignItems="center" gap={1}>
                      <img
                        src={lightbulb}
                        alt="Lightbulb"
                        style={{
                          width: 16,
                          height: 16,
                          // border: '1px solid',
                          filter: (() => {
                            const score = candidate.score_matching;
                            if (score >= 70)
                              return "invert(39%) sepia(96%) saturate(408%) hue-rotate(72deg) brightness(92%) contrast(101%)";
                            if (score >= 40 && score <= 60)
                              return "invert(74%) sepia(96%) saturate(747%) hue-rotate(359deg) brightness(102%) contrast(101%)";
                            if (score < 40)
                              return "invert(11%) sepia(100%) saturate(747%) hue-rotate(359deg) brightness(99%) contrast(101%)";
                            return "invert(39%) sepia(96%) saturate(408%) hue-rotate(72deg) brightness(92%) contrast(101%)";
                          })(),
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                          fontWeight: 700,
                          color: (() => {
                            const score = candidate.score_matching;
                            if (score >= 70) return "#00BA19";
                            if (score >= 40 && score <= 60) return "#FFA800";
                            if (score < 40) return "#C10000";
                            return "#00BA19";
                          })(),
                        }}
                      >
                        {`${candidate.score_matching || "NaN"}%`}
                      </Typography>
                    </Box>
                  }
                  sx={{
                    borderRadius: "10px",
                    borderColor: (() => {
                      const score = candidate.score_matching;
                      if (score >= 70) return "#00BA19";
                      if (score >= 40 && score <= 60) return "#FFA800";
                      if (score < 40) return "#C10000";
                      return "#00BA19";
                    })(),
                    borderWidth: 1,
                    backgroundColor: (() => {
                      const score = candidate.score_matching;
                      if (score >= 70) return "rgba(0, 186, 25, 0.32)";
                      if (score >= 40 && score <= 60)
                        return "rgba(255, 168, 0, 0.32)";
                      if (score < 40) return "rgba(193, 0, 0, 0.32)";
                      return "rgba(0, 186, 25, 0.32)";
                    })(),
                  }}
                />
                <Typography
                  sx={{ fontSize: "0.875rem", mt: 0.5, fontFamily: "Poppins" }}
                >
                  Évaluation de l'IA
                </Typography>
              </Box>

              {/* Dropdown Button */}
              <Button
                sx={{
                  height: 50,
                  aspectRatio: "1 / 1",
                  border: `1px solid ${colors.primary}`,
                  borderRadius: 4,
                  minWidth: 0,
                  p: 0,
                  ml: 4,
                  transition: "transform 0.3s ease, background-color 0.2s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded(!expanded);
                }}
              >
                <img
                  src={dropdown_icon}
                  alt="Dropdown"
                  style={{
                    height: 16,
                    width: 16,
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                />
              </Button>
            </Box>
          </Box>
        </Box>

        {/* MAIN CARD CONTENT */}
        <Card
          ref={ref}
          onClick={onClick}
          sx={{
            borderRadius: 6,
            boxShadow: isHighlighted
              ? "0 0 0 3px rgba(0, 23, 231, 0.3)"
              : "0 1px 3px rgba(0,0,0,0.1)",
            border: isSelected
              ? `2px solid ${colors.primary}`
              : isHighlighted
                ? `2px solid ${colors.primary}`
                : "1px solid #d9d9d9",
            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            backgroundColor: isSelected
              ? "rgba(0, 23, 231, 0.02)"
              : isHighlighted
                ? "rgba(0, 23, 231, 0.05)"
                : "white",
            overflow: cardOverflow,
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            },
          }}
        >
          {/* COLLAPSED VIEW */}
          <Collapse in={!expanded} timeout={400}>
            <CardContent sx={{ p: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 4,
                  opacity: expanded ? 0 : 1,
                  transition: "opacity 0.2s ease",
                }}
              >
                {/* Left: Checkbox and Name */}
                <Box
                  sx={{
                    flexShrink: 0,
                    width: 220,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Checkbox
                    onClick={(e) => e.stopPropagation()}
                    checked={isSelected}
                    onChange={(e) => onSelect(e.target.checked)}
                    sx={{
                      color: colors.primary,
                      "&.Mui-checked": {
                        color: colors.primary,
                      },
                    }}
                  />
                  <Box>
                    {candidate.status !== "Application-Imported" &&
                      candidate.status !== "Application Spontane" &&
                      candidate.status !== "Scraping-Email" ? (
                      <Typography variant="h5" fontWeight="bold">
                        {candidate.candidate?.first_name || ""}{" "}
                        {candidate.candidate?.last_name || ""}
                        {age !== 0 ? `, ${age}` : ""}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "1.25rem",
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                        }}
                      >
                        {candidate.extracted_informations?.Name}
                        {candidate.extracted_informations?.Age
                          ? `, ${candidate.extracted_informations?.Age}`
                          : ""}
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Center: Badges and Contact Info */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 2,
                    }}
                  >
                    {/* Role Badges */}
                    <Box
                      sx={{ display: "flex", alignItems: "start", gap: 1.5 }}
                    >
                      <Chip
                        icon={<Wrench size={16} />}
                        label={
                          typeof candidate.extracted_informations?.Profil ===
                            "string"
                            ? candidate.extracted_informations?.Profil
                            : Array.isArray(
                              candidate.extracted_informations?.Profil
                            )
                              ? candidate.extracted_informations?.Profil.join(
                                ", "
                              )
                              : "\u00A0"
                        }
                        variant="outlined"
                        sx={{
                          borderColor: "#0017e7",
                          color: "#0017e7",
                          borderWidth: 1,
                          fontWeight: 500,
                          "& .MuiChip-icon": { color: "#0017e7" },
                          borderRadius: "10px",
                        }}
                      />
                      <Chip
                        icon={<MapPinned size={16} />}
                        label={
                          candidate.extracted_informations?.agexperiece
                            ? `+ ${Math.floor(
                              candidate.extracted_informations.agexperiece
                            )} ans`
                            : "NaN"
                        }
                        variant="outlined"
                        sx={{
                          borderColor: "#0017e7",
                          color: "#0017e7",
                          borderWidth: 1,
                          fontWeight: 500,
                          "& .MuiChip-icon": { color: "#0017e7" },
                          borderRadius: "10px",
                        }}
                      />
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#6366f1",
                          borderRadius: 3,
                          fontWeight: 600,
                          textTransform: "none",
                          "&:hover": { bgcolor: "#4f46e5" },
                        }}
                      >
                        {candidate.status === "Application-Imported"
                          ? "Candidature Importée"
                          : candidate.status === "Application Spontane"
                            ? "Candidature Spontanée"
                            : candidate.status}
                      </Button>
                    </Box>

                    {/* Contact Information */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Mail size={20} color="#0017e7" />
                        <Typography
                          sx={{ fontWeight: 500, fontFamily: "Poppins" }}
                        >
                          {typeof candidate.extracted_informations?.Email ===
                            "string"
                            ? candidate.extracted_informations?.Email
                            : Array.isArray(
                              candidate.extracted_informations?.Email
                            )
                              ? candidate.extracted_informations?.Email.join(", ")
                              : "No email provided"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <LinkedInIcon sx={{ color: "#0017e7", fontSize: 20 }} />
                        <Typography
                          sx={{ fontWeight: 500, fontFamily: "Poppins" }}
                        >
                          LinkedIn Profile
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Right: Placeholder for fixed score and button */}
                <Box sx={{ flexShrink: 0, width: 200 }} />
              </Box>
            </CardContent>
          </Collapse>

          {/* EXPANDED VIEW */}
          <Collapse
            in={expanded}
            timeout={400}
            onEntered={() => setCardOverflow("visible")}
            onExiting={() => setCardOverflow("hidden")}
            sx={{ overflow: cardOverflow }}
          >
            <Paper
              className="candidate-card-expanded"
              sx={{
                borderRadius: 6,
                p: 3,
                position: "relative",
                transition: "all 0.3s ease-in-out",
                borderTop: "2px solid transparent",
                overflow: "visible",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: "-2px",
                  right: "14px",
                  width: "200px",
                  height: "0px",
                  border: `2px solid ${colors.primary}`,
                  borderBottom: "2px solid #ffffff",
                  borderTopLeftRadius: "20px",
                  borderTopRightRadius: "20px",
                  backgroundColor: "#ffffff",
                  zIndex: 2,
                  opacity: 0,
                  transition: "top 0.35s cubic-bezier(0.4, 0, 0.2, 1), height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-in-out",
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  top: "-2px",
                  right: "198px",
                  width: "32px",
                  height: "0px",
                  background: `radial-gradient(circle at top left, transparent 16px, ${colors.primary} 16px, ${colors.primary} 18px, #ffffff 18px)`,
                  zIndex: 2,
                  opacity: 0,
                  transition: "top 0.35s cubic-bezier(0.4, 0, 0.2, 1), height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-in-out",
                },
                "&:hover": {
                  borderTop: `2px solid ${colors.primary}`,
                  "&::before": {
                    top: "-62px",
                    height: "64px",
                    opacity: 1,
                  },
                  "&::after": {
                    top: "-18px",
                    height: "18px",
                    opacity: 1,
                  },
                  "& .action-buttons-container": {
                    opacity: 1,
                    visibility: "visible",
                    transform: "translateY(0)",
                  },
                },
              }}
            >
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    mb={false}
                    sx={{ gap: 2, justifyContent: "space-between", position: "relative" }}
                  >


                    {/* Action Buttons - Top Right - Visible on Hover with Curved Expanding Border */}
                    <Box
                      className="action-buttons-container"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        opacity: 0,
                        visibility: "hidden",
                        transform: "translateY(10px)",
                        transition: "all 0.3s ease-in-out",
                        position: "absolute",
                        top: "-62px",
                        right: "3px",
                        zIndex: 3,
                      }}
                    >
                      <Tooltip
                        title={t("contact_candidate")}
                        placement="bottom"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: colors.primary,
                              color: "white",
                              fontSize: "0.75rem",
                              fontFamily: "Poppins",
                              padding: "8px 12px",
                              borderRadius: "8px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              "& .MuiTooltip-arrow": {
                                color: colors.primary,
                              },
                            },
                          },
                        }}
                      >
                        <IconButton
                          variant="outlined"
                          sx={{
                            backgroundColor: "white",
                            color: `${colors.primary}`,
                            //border: `1px solid ${colors.primary}`,
                            borderRadius: "30%",
                            "&:hover": {
                              backgroundColor: "#2563eb",
                              "& img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                            width: { xs: 30, sm: 38 },
                            height: { xs: 30, sm: 38 },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEmailClickContact(e);
                          }}
                        >
                          <img
                            src={mail_icon}
                            alt="contact"
                            style={{
                              transition: "filter 0.2s ease",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={t("historique_candidate")}
                        placement="bottom"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: colors.primary,
                              color: "white",
                              fontSize: "0.75rem",
                              fontFamily: "Poppins",
                              padding: "8px 12px",
                              borderRadius: "8px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              "& .MuiTooltip-arrow": {
                                color: colors.primary,
                              },
                            },
                          },
                        }}
                      >
                        <IconButton
                          variant="outlined"
                          sx={{
                            backgroundColor: "white",
                            color: `${colors.primary}`,
                            //border: `1px solid ${colors.primary}`,
                            borderRadius: "30%",
                            "&:hover": {
                              backgroundColor: "#2563eb",
                              "& img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                            width: { xs: 30, sm: 38 },
                            height: { xs: 30, sm: 38 },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEmailHistoryClick(e);
                          }}
                        >
                          <img
                            src={expand_icon}
                            alt="historique"
                            style={{
                              transition: "filter 0.2s ease",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={t("resume_candidate")}
                        placement="bottom"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: colors.primary,
                              color: "white",
                              fontSize: "0.75rem",
                              fontFamily: "Poppins",
                              padding: "8px 12px",
                              borderRadius: "8px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              "& .MuiTooltip-arrow": {
                                color: colors.primary,
                              },
                            },
                          },
                        }}
                      >
                        <IconButton
                          variant="outlined"
                          sx={{
                            backgroundColor: "white",
                            color: `${colors.primary}`,
                            // border: `1px solid ${colors.primary}`,
                            borderRadius: "30%",
                            "&:hover": {
                              backgroundColor: "#2563eb",
                              "& img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                            width: { xs: 30, sm: 38 },
                            height: { xs: 30, sm: 38 },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleResumeClick(e);
                          }}
                        >
                          <img
                            src={file_icon}
                            alt="resume"
                            style={{
                              transition: "filter 0.2s ease",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={t("cover_letter")}
                        placement="bottom"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: colors.primary,
                              color: "white",
                              fontSize: "0.75rem",
                              fontFamily: "Poppins",
                              padding: "8px 12px",
                              borderRadius: "8px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              "& .MuiTooltip-arrow": {
                                color: colors.primary,
                              },
                            },
                          },
                        }}
                      >
                        <IconButton
                          variant="outlined"
                          sx={{
                            backgroundColor: "white",
                            color: `${colors.primary}`,
                            //border: `1px solid ${colors.primary}`,
                            borderRadius: "30%",
                            "&:hover": {
                              backgroundColor: "#2563eb",
                              "& img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                            width: { xs: 30, sm: 38 },
                            height: { xs: 30, sm: 38 },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleLetterClick(e);
                          }}
                        >
                          <img
                            src={open_book}
                            alt="letter de motivation"
                            style={{
                              transition: "filter 0.2s ease",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  <Grid container>
                    <Grid item xs={0.8}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
                        <Checkbox
                          checked={isSelected}
                          onChange={(e) => onSelect(e.target.checked)}
                          onClick={(e) => e.stopPropagation()}
                          sx={{
                            color: colors.primary,
                            "&.Mui-checked": {
                              color: colors.primary,
                            },
                          }}
                        />
                        {/* <Avatar
                      sx={{
                        width: 66,
                        height: 66,
                        background: colors.primary,
                        // "linear-gradient(to bottom right, #c084fc, #9333ea)",
                        fontSize: "0.5rem",
                        fontWeight: "bold",
                      }}
                    >
                      {`${candidate.candidate?.first_name?.[0] || ""}${
                        candidate.candidate?.last_name?.[0] || ""
                      }`}
                    </Avatar> */}
                      </Box>
                    </Grid>
                    <Grid item xs={11.2}>

                      <Grid container>

                        <Grid item xs={12}>
                          <Box display="flex" alignItems="center" gap={1} sx={{ ml: -1 }}>
                            {candidate.status !== "Application-Imported" &&
                              candidate.status !== "Application Spontane" &&
                              candidate.status !== "Scraping-Email" ? (
                              <Typography
                                sx={{
                                  fontSize: "1.25rem",
                                  fontWeight: "bold",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {candidate.candidate?.first_name || ""}{" "}
                                {candidate.candidate?.last_name || ""}
                                {age !== 0 ? `, ${age}` : ""}
                              </Typography>
                            ) : (
                              <Typography
                                sx={{
                                  fontSize: "1.55rem",
                                  fontWeight: 550,
                                  fontFamily: "Poppins",
                                }}
                              >
                                {candidate.extracted_informations?.Name}
                                {candidate.extracted_informations?.Age
                                  ? `, ${candidate.extracted_informations?.Age}`
                                  : ""}
                              </Typography>
                            )}
                            <Typography variant="h6" color={`${colors.primary}`}>
                              •
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: 400,
                                fontFamily: "Poppins",
                                textTransform: "none",
                                color: colors.primary,
                              }}
                            >
                              {typeof candidate.extracted_informations?.Profil ===
                                "string"
                                ? candidate.extracted_informations?.Profil
                                : Array.isArray(
                                  candidate.extracted_informations?.Profil
                                )
                                  ? candidate.extracted_informations?.Profil.join(
                                    ", "
                                  )
                                  : "\u00A0"}
                            </Typography>
                            <Typography variant="h6" color={`${colors.primary}`}>
                              •
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: 400,
                                fontFamily: "Poppins",
                                textTransform: "none",
                                color: colors.primary,
                              }}
                            >
                              {candidate.extracted_informations?.agexperiece
                                ? `+ ${Math.floor(
                                  candidate.extracted_informations.agexperiece
                                )} ans`
                                : "NaN"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box sx={{ display: "flex", gap: 1.5, ml: -1.5 }}>
                            {/* <Chip
                          icon={<Mail />}
                          label={t("applicationTable.email")}
                          variant="outlined"
                          clickable
                          onClick={() =>
                            (window.location.href = `mailto:${candidate.extracted_informations?.Email}`)
                          }
                          sx={{
                            borderColor: "#0017e7",
                            color: "#0017e7",
                            borderWidth: 1,
                            fontWeight: 500,
                            "& .MuiChip-icon": { color: "#0017e7" },
                            borderRadius: "10px",
                          }}
                        /> */}
                            <Button
                              clickable
                              onClick={(e) => {
                                e.stopPropagation();
                                window.location.href = `mailto:${candidate.extracted_informations?.Email}`;
                              }}
                            >
                              <img src={mail_icon} alt="Mail" />
                              <Typography
                                sx={{
                                  fontWeight: 400,
                                  fontFamily: "Poppins",
                                  textTransform: "none",
                                  ml: 1,
                                  color: "#000",
                                }}
                              >
                                {candidate.extracted_informations?.Email ||
                                  "No email provided"}
                              </Typography>
                            </Button>
                            <Button
                              clickable
                              onClick={(e) => {
                                e.stopPropagation();
                                searchProfile(
                                  candidate.extracted_informations?.Name
                                );
                              }}
                            >
                              <img src={linkedin_icon} alt="Linedin" />
                              <Typography
                                sx={{
                                  fontWeight: 400,
                                  fontFamily: "Poppins",
                                  textTransform: "none",
                                  ml: 1,
                                  color: "#000",
                                }}
                              >
                                {candidate.extracted_informations?.Name ||
                                  "No email provided"}
                              </Typography>
                            </Button>
                            {/* <Chip
                            icon={<LinkedInIcon />}
                            label={t("applicationTable.linkedin")}
                            variant="outlined"
                            clickable
                            sx={{
                              borderColor: "#0017e7",
                              color: "#0017e7",
                              borderWidth: 1,
                              fontWeight: 500,
                              "& .MuiChip-icon": { color: "#0017e7" },
                              borderRadius: "10px",
                            }}
                          /> */}
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={4} sx={{ mt: 0.1 }}>
                {/* Left Column - Avatar */}
                {/* <Grid item xs={12} lg={1}></Grid> */}

                {/* Middle-Left Column */}
                <Grid item xs={12} lg={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                      mt: -0.8,
                    }}
                  >
                    {/* Placeholder for fixed name - keeps spacing consistent */}
                    {/* <Box sx={{ height: 0 }} />

                    <Chip
                      icon={<Wrench size={16} />}
                      label={
                        typeof candidate.extracted_informations?.Profil ===
                        "string"
                          ? candidate.extracted_informations?.Profil
                          : Array.isArray(
                              candidate.extracted_informations?.Profil
                            )
                          ? candidate.extracted_informations?.Profil.join(", ")
                          : "\u00A0"
                      }
                      variant="outlined"
                      sx={{
                        borderColor: "#0017e7",
                        color: "#0017e7",
                        borderWidth: 1,
                        fontWeight: 500,
                        "& .MuiChip-icon": { color: "#0017e7" },
                        borderRadius: "10px",
                        width: "fit-content",
                      }}
                    />

                    <Box sx={{ display: "flex", gap: 1.5 }}>
                      <Chip
                        icon={<Mail />}
                        label="Email"
                        variant="outlined"
                        clickable
                        onClick={() =>
                          (window.location.href = `mailto:${candidate.extracted_informations?.Email}`)
                        }
                        sx={{
                          borderColor: "#0017e7",
                          color: "#0017e7",
                          borderWidth: 1,
                          fontWeight: 500,
                          "& .MuiChip-icon": { color: "#0017e7" },
                          borderRadius: "10px",
                        }}
                      />
                      <Chip
                        icon={<LinkedInIcon />}
                        label="Linkedin"
                        variant="outlined"
                        clickable
                        sx={{
                          borderColor: "#0017e7",
                          color: "#0017e7",
                          borderWidth: 1,
                          fontWeight: 500,
                          "& .MuiChip-icon": { color: "#0017e7" },
                          borderRadius: "10px",
                        }}
                      />
                    </Box> */}

                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                        }}
                      >
                        <SchoolIcon fontSize="small" />
                        <Typography
                          sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            fontFamily: "Poppins",
                            textTransform: "none",
                            color: "#000",
                          }}
                        >
                          {t("applicationTable.formation")}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          overflow: "hidden",
                        }}
                      >
                        {(() => {
                          let education = processEducation(
                            candidate.extracted_informations?.Education
                          );

                          // If it's a nested array, get the inner array
                          if (
                            Array.isArray(education) &&
                            education.length === 1 &&
                            Array.isArray(education[0])
                          ) {
                            education = education[0];
                          }

                          if (
                            !Array.isArray(education) ||
                            education.length === 0
                          ) {
                            return <Chip label={t("applicationTable.noEducation")} />;
                          }

                          // Parse education text into separate chips
                          let educationChips = [];

                          education.forEach((edu) => {
                            // Handle new format: {title, subtitle, date_range, description}
                            // Handle old format: {text, date_range} or {degree, ...}
                            const title = edu?.title || edu?.text || edu?.degree || edu;
                            const subtitle = edu?.subtitle;
                            const dateRange = edu?.date_range;

                            if (typeof title === "string" && title.trim()) {
                              educationChips.push(title);

                              // Add subtitle if it exists
                              if (subtitle && typeof subtitle === "string" && subtitle.trim()) {
                                educationChips.push(subtitle);
                              }

                              // Add date range if it exists
                              if (dateRange && typeof dateRange === "string" && dateRange.trim()) {
                                educationChips.push(dateRange);
                              }
                            } else if (typeof title === "object") {
                              // Fallback: if title is still an object, try to stringify it
                              console.warn("Education item is an object:", edu);
                            }
                          });

                          const firstTwo = educationChips.slice(0, 2);
                          const hasMore = educationChips.length > 2;

                          return (
                            <>
                              {firstTwo.map((label, index) => {
                                console.log(`CHIP ${index}:`, label);

                                return (
                                  <Chip
                                    key={index}
                                    // icon={<SchoolIcon />}
                                    label={label}
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#0017E70D",
                                      borderRadius: 2.5,
                                      borderColor: colors.primary,
                                      color: colors.primary,
                                      maxWidth: "94px",
                                      "& .MuiChip-label": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                      "& .MuiChip-icon": {
                                        color: colors.primary,
                                      },
                                    }}
                                  />
                                );
                              })}

                              {hasMore && (
                                <Chip
                                  label={t("applicationTable.seeMore")}
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openEducationModal();
                                  }}
                                  sx={{
                                    borderRadius: 2.5,
                                    borderColor: colors.primary,
                                    color: colors.primary,
                                    backgroundColor: "#0017E70D",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#eff6ff",
                                    },
                                  }}
                                />
                              )}
                            </>
                          );
                        })()}
                      </Box>
                    </Box>

                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                        }}
                      >
                        <Language fontSize="small" />
                        <Typography
                          sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            fontFamily: "Poppins",
                            textTransform: "none",
                            color: "#000",
                          }}
                        >
                          {t("applicationTable.languages")}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          overflow: "hidden",
                        }}
                      >
                        {(() => {
                          const languages = processLanguages(
                            candidate.extracted_informations?.Language
                          );

                          if (
                            !Array.isArray(languages) ||
                            languages.length === 0
                          ) {
                            return <Chip label={t("applicationTable.noLanguages")} />;
                          }

                          const firstTwo = languages.slice(0, 2);
                          const hasMore = languages.length > 2;

                          return (
                            <>
                              {firstTwo.map((label, index) => {
                                return (
                                  <Chip
                                    key={index}
                                    label={
                                      label.length > 8
                                        ? label.slice(0, 8) + "..."
                                        : label
                                    }
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#0017E70D",
                                      borderRadius: 2.5,
                                      borderColor: colors.primary,
                                      color: colors.primary,
                                      maxWidth: "94px",
                                      "& .MuiChip-label": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                    }}
                                  />
                                );
                              })}

                              {hasMore && (
                                <Chip
                                  label={t("applicationTable.seeMore")}
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openLanguagesModal();
                                  }}
                                  sx={{
                                    borderRadius: 2.5,
                                    borderColor: colors.primary,
                                    color: colors.primary,
                                    backgroundColor: "#0017E70D",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#eff6ff",
                                    },
                                  }}
                                />
                              )}
                            </>
                          );
                        })()}
                      </Box>
                    </Box>

                  </Box>
                </Grid>

                {/* Middle-Right Column */}
                <Grid item xs={12} lg={3.8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                      mt: 0,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 16,
                          fontWeight: 500,
                          fontFamily: "Poppins",
                          textTransform: "none",
                          color: "#000",
                          mb: 1,
                        }}
                      >
                        {t("applicationTable.experiences")}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          overflow: "hidden",
                        }}
                      >
                        {(() => {
                          const experiences = processExperiences(
                            candidate.extracted_informations?.EXPERIENCE
                          );

                          if (
                            !Array.isArray(experiences) ||
                            experiences.length === 0
                          ) {
                            return (
                              <Chip
                                label={`+ ${Math.floor(
                                  candidate.extracted_informations
                                    ?.agexperiece || 0
                                )} ${t("applicationTable.ans")}`}
                              />
                            );
                          }

                          const firstTwo = experiences.slice(0, 2);
                          const hasMore = experiences.length > 2;

                          return (
                            <>
                              {firstTwo.map((exp, index) => {
                                // Handle new format: {title, subtitle, date_range, description}
                                // Handle old format: {position, company, ...}
                                const label = exp?.title || exp?.position || exp;
                                const labelStr = typeof label === "string" ? label : t("applicationTable.unknownPosition");
                                return (
                                  <Chip
                                    key={index}
                                    label={
                                      labelStr.length > 8
                                        ? labelStr.slice(0, 11) + "..."
                                        : labelStr
                                    }
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#0017E70D",
                                      borderRadius: 2.5,
                                      borderColor: colors.primary,
                                      color: colors.primary,
                                      maxWidth: "94px",
                                      "& .MuiChip-label": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                      "& .MuiChip-icon": {
                                        color: colors.primary,
                                      },
                                    }}
                                  />
                                );
                              })}

                              {hasMore && (
                                <Chip
                                  label={t("applicationTable.seeMore")}
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openExperienceModal();
                                  }}
                                  sx={{
                                    borderRadius: 2.5,
                                    borderColor: colors.primary,
                                    color: colors.primary,
                                    backgroundColor: "#0017E70D",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#eff6ff",
                                    },
                                  }}
                                />
                              )}
                            </>
                          );
                        })()}
                      </Box>
                    </Box>

                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                        }}
                      >
                        <WorkspacePremium fontSize="small" />
                        <Typography
                          sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            fontFamily: "Poppins",
                            textTransform: "none",
                            color: "#000",
                          }}
                        >
                          {t("applicationTable.certificates")}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          overflow: "hidden",
                        }}
                      >
                        {(() => {
                          const certificates = processLanguages(
                            candidate.extracted_informations?.Certificates
                          );

                          if (
                            !Array.isArray(certificates) ||
                            certificates.length === 0
                          ) {
                            return <Chip label={t("applicationTable.noCertificates")} />;
                          }

                          const firstTwo = certificates.slice(0, 2);
                          const hasMore = certificates.length > 2;

                          return (
                            <>
                              {firstTwo.map((label, index) => {
                                return (
                                  <Chip
                                    key={index}
                                    label={
                                      label.length > 8
                                        ? label.slice(0, 11) + "..."
                                        : label
                                    }
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#0017E70D",
                                      borderRadius: 2.5,
                                      borderColor: colors.primary,
                                      color: colors.primary,
                                      maxWidth: "94px",
                                      "& .MuiChip-label": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                    }}
                                  />
                                );
                              })}

                              {hasMore && (
                                <Chip
                                  label={t("applicationTable.seeMore")}
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openCertificatesModal();
                                  }}
                                  sx={{
                                    borderRadius: 2.5,
                                    borderColor: colors.primary,
                                    color: colors.primary,
                                    backgroundColor: "#0017E70D",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#eff6ff",
                                    },
                                  }}
                                />
                              )}
                            </>
                          );
                        })()}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                {/* <Grid item xs={12} lg={0.1}>
                  <Divider
                    orientation="vertical"
                    sx={{
                      borderColor: "#0000001A",
                      width: "80%",
                      display: "flex",
                      margin: "0 auto",
                      // alignItems: 'center',
                      // justifyContent: 'center',
                    }}
                  />
                </Grid> */}

                {/* Right Column - Actions */}
                <Grid item xs={12} lg={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      mt: -5,
                    }}
                  >
                    {/* Placeholder for fixed score - keeps spacing consistent */}
                    <Box sx={{ height: 0, mb: 0 }} />

                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#6366f1",
                        borderRadius: 3,
                        fontWeight: 600,
                        textTransform: "none",
                        "&:hover": { bgcolor: "#4f46e5" },
                      }}
                    >
                      {candidate.status === "Application-Imported"
                        ? t("applicationTable.scrapedApplication")
                        : candidate.status === "Application Spontane"
                          ? t("spontaneous.title")
                          : candidate.status}
                    </Button>

                    <Box display="flex" alignItems="center">
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 500,
                          fontFamily: "Poppins",
                          textTransform: "none",
                          color: "#000",
                          mr: 2,
                        }}
                      >
                        {t("applicationTable.status")} :
                      </Typography>
                      <SplitButton
                        steps={steps}
                        currentStep={candidate.step}
                        applicationId={candidate.id}
                        email={candidate?.extracted_informations?.Email || ""}
                        status={candidate.status}
                        user_id={getUserIdFromAccessToken()}
                        post={post_id}
                        onStepUpdate={onCandidatesUpdate}
                      />
                    </Box>
                    <Divider
                      sx={{
                        borderColor: "#0000001A",
                        width: "100%",
                        display: "flex",
                        margin: "0 auto",
                      }}
                    />
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                        }}
                      >
                        <SchoolIcon fontSize="small" />
                        <Typography
                          sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            fontFamily: "Poppins",
                            textTransform: "none",
                            color: "#000",
                          }}
                        >
                          {t("applicationTable.skills")}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          overflow: "hidden",
                        }}
                      >
                        {(() => {
                          const skills = processLanguages(
                            candidate.extracted_informations?.Skills
                          );

                          if (!Array.isArray(skills) || skills.length === 0) {
                            return <Chip label={t("applicationTable.noSkills")} />;
                          }

                          const firstTwo = skills.slice(0, 2);
                          const hasMore = skills.length > 2;

                          return (
                            <>
                              {firstTwo.map((label, index) => {
                                return (
                                  <Chip
                                    key={index}
                                    label={
                                      label.length > 8
                                        ? label.slice(0, 8) + "..."
                                        : label
                                    }
                                    variant="outlined"
                                    sx={{
                                      backgroundColor: "#0017E70D",
                                      borderRadius: 2.5,
                                      borderColor: colors.primary,
                                      color: colors.primary,
                                      maxWidth: "94px",
                                      "& .MuiChip-label": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                      "& .MuiChip-icon": {
                                        color: colors.primary,
                                      },
                                    }}
                                  />
                                );
                              })}

                              {hasMore && (
                                <Chip
                                  label={t("applicationTable.seeMore")}
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openSkillsModal();
                                  }}
                                  sx={{
                                    borderRadius: 2.5,
                                    borderColor: colors.primary,
                                    color: colors.primary,
                                    backgroundColor: "#0017E70D",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#eff6ff",
                                    },
                                  }}
                                />
                              )}
                            </>
                          );
                        })()}
                      </Box>
                    </Box>
                  </Box>
                </Grid>

                {/* Right Icon Column - Placeholder for fixed button */}
                {/* <Grid item xs={12} lg={1.5}>
                  <Box sx={{ height: 60 }} />
                </Grid> */}
              </Grid>
            </Paper>
          </Collapse>
        </Card>
      </Box>
      {/* Unified Resume Dialog */}
      <StyledDialog
        open={showUnifiedResumeDialog}
        onClose={closeUnifiedResumeDialog}
        maxWidth={false}
        fullWidth={false}
        PaperProps={{
          sx: {
            margin: 0,
            maxHeight: "100vh",
            height: "100vh",
            width: "50vw",
            maxWidth: "50vw",
            position: "fixed",
            right: 0,
            top: 0,
            borderRadius: 0,
            overflow: "hidden",
            transition: "transform 0.3s ease-in-out",
            transform: showUnifiedResumeDialog
              ? "translateX(0)"
              : "translateX(100%)",
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
            boxShadow: "none",
          },
        }}
        sx={{
          "& .MuiBackdrop-root": {
            transition: "opacity 0.3s ease-in-out",
            opacity: showUnifiedResumeDialog ? 1 : 0,
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#f5f5f5",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
            paddingLeft: "16px",
            paddingRight: "16px",
            opacity: showUnifiedResumeDialog ? 1 : 0,
            transition: "opacity 0.2s ease-in-out 0.1s",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            <Box>
              <Typography
                variant="h5"
                component="div"
                sx={{ fontWeight: 600, color: "#333", fontFamily: "Poppins" }}
              >
                {t("applicationTable.candidateDetails")}
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{
                  fontWeight: 500,
                  color: "#666",
                  mt: 0.5,
                  fontSize: "1rem",
                  fontFamily: "Poppins",
                }}
              >
                {candidate.status !== "Application-Imported" &&
                  candidate.status !== "Application Spontane" &&
                  candidate.status !== "Scraping-Email" ? (
                  <>
                    {candidate.candidate?.first_name || ""}{" "}
                    {candidate.candidate?.last_name || ""}
                  </>
                ) : (
                  <>{candidate.extracted_informations?.Name || ""}</>
                )}
              </Typography>
            </Box>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={closeUnifiedResumeDialog}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <StyledDialogContent
          dividers
          sx={{
            padding: 0,
            height: "calc(100% - 64px)",
            overflow: "auto",
            opacity: showUnifiedResumeDialog ? 1 : 0,
            transition: "opacity 0.2s ease-in-out 0.1s",
            border: "none",
          }}
        >
          <Box sx={{ p: 3 }} id="resume-container">


            {/* Education Section */}
            <Box
              id="education-section"
              sx={{
                mb: 4,
                scrollMarginTop: "64px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <SchoolIcon fontSize="small" />
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: "#000",
                  }}
                >
                  {t("applicationTable.education")}
                </Typography>
              </Box>
              <Box sx={{ pl: 2 }}>
                {processEducation(
                  candidate.extracted_informations?.Education
                ).map((education, index) => (
                  <Box
                    key={index}
                    sx={{
                      mb: 3,
                      p: 2.5,
                      borderRadius: 2,
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      backgroundColor: index % 2 === 0 ? "#f9fafb" : "#ffffff",
                      transition: "transform 0.2s",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2, mb: 1 }}>
                      <Typography
                        variant="body1"
                        component="div"
                        sx={{
                          color: "#0017E7", // Updated to match blue title color
                          fontSize: "1rem",
                          fontWeight: 600,
                          lineHeight: 1.6,
                          whiteSpace: "pre-line",
                          fontFamily: "Poppins",
                          flex: 1,
                        }}
                      >
                        {education.title || education.text}
                      </Typography>

                      {/* Date Range as Chip */}
                      {education.date_range && education.date_range !== "date_range not found" && (
                        <Chip
                          label={education.date_range}
                          size="small"
                          sx={{
                            backgroundColor: "rgba(0, 23, 231, 0.08)",
                            color: "#0017E7",
                            border: "1px solid rgba(0, 23, 231, 0.15)",
                            fontWeight: 500,
                            fontSize: "0.8rem",
                            height: "24px",
                            flexShrink: 0,
                            fontFamily: "Poppins",
                          }}
                        />
                      )}
                    </Box>

                    {education.subtitle && (
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          color: "rgba(0, 23, 231, 0.8)", // Updated to match subtitle color
                          fontSize: "0.9rem",
                          fontWeight: 500,
                          mt: 0.5,
                          mb: 1,
                          fontFamily: "Poppins",
                        }}
                      >
                        {education.subtitle}
                      </Typography>
                    )}

                    {/* Education Description */}
                    {education.description && (
                      <Box sx={{ mt: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#555",
                            fontSize: "0.9rem",
                            lineHeight: 1.5,
                            whiteSpace: "pre-line",
                            fontFamily: "Poppins",
                          }}
                        >
                          {education.description}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Languages Section */}
            <Box
              id="languages-section"
              sx={{
                mb: 4,
                scrollMarginTop: "64px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <Language fontSize="small" />
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: "#000",
                  }}
                >
                  {t("applicationTable.languages")}
                </Typography>
              </Box>
              <Box sx={{ pl: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {processLanguages(
                  candidate.extracted_informations?.Language
                ).map((language, index) => (
                  <Chip
                    key={index}
                    label={language}
                    sx={{
                      backgroundColor: "#0017E70D",
                      borderRadius: 2.5,
                      borderColor: colors.primary,
                      color: colors.primary,
                      maxWidth: "94px",
                      "& .MuiChip-label": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontFamily: "Poppins",
                      },
                      "& .MuiChip-icon": {
                        color: colors.primary,
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>

            {/* Skills Section */}
            <Box
              id="skills-section"
              sx={{
                mb: 4,
                scrollMarginTop: "64px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <Wrench size={20} />
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: "#000",
                  }}
                >
                  {t("applicationTable.skills")}
                </Typography>
              </Box>
              <Box sx={{ pl: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {processLanguages(candidate.extracted_informations?.Skills).map(
                  (skill, index) => (
                    <Chip
                      key={index}
                      label={skill}
                      sx={{
                        backgroundColor: "#0017E70D",
                        borderRadius: 2.5,
                        borderColor: colors.primary,
                        color: colors.primary,
                        maxWidth: "100%",
                        "& .MuiChip-label": {
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontFamily: "Poppins",
                        },
                        "& .MuiChip-icon": {
                          color: colors.primary,
                        },
                      }}
                    />
                  )
                )}
              </Box>
            </Box>

            {/* Experience Section */}
            <Box
              id="experience-section"
              sx={{
                mb: 4,
                scrollMarginTop: "64px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <Briefcase size={20} />
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: "#000",
                  }}
                >
                  {t("applicationTable.experience")}
                </Typography>
              </Box>
              <Box sx={{ pl: 2 }}>
                {processExperiences(
                  candidate.extracted_informations?.EXPERIENCE
                ).map((experience, index) => (
                  <Box
                    key={index}
                    sx={{
                      mb: 3,
                      p: 2.5,
                      borderRadius: 2,
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      backgroundColor: index % 2 === 0 ? "#f9fafb" : "#ffffff",
                      transition: "transform 0.2s",
                      // "&:hover": {
                      //   transform: "translateY(-2px)",
                      //   boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
                      // },
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2, mb: 1 }}>
                      {/* Title (Position) */}
                      <Typography
                        variant="h6"
                        component="div"
                        sx={{
                          color: "#0017E7", // Updated to match blue title color
                          fontSize: "1.3rem",
                          fontWeight: 600,
                          fontFamily: "Poppins",
                          flex: 1,
                        }}
                      >
                        {experience.title || experience.position || t("applicationTable.unknownPosition")}
                      </Typography>

                      {/* Date Range as Chip */}
                      {experience.date_range && (
                        <Chip
                          label={experience.date_range}
                          size="small"
                          sx={{
                            backgroundColor: "rgba(0, 23, 231, 0.08)",
                            color: "#0017E7",
                            border: "1px solid rgba(0, 23, 231, 0.15)",
                            fontWeight: 500,
                            fontSize: "0.8rem",
                            height: "24px",
                            flexShrink: 0,
                            fontFamily: "Poppins",
                          }}
                        />
                      )}
                    </Box>

                    {/* Subtitle (Company) */}
                    {(experience.subtitle || experience.company) && (
                      <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{
                          color: "rgba(0, 23, 231, 0.8)", // Updated to match subtitle color
                          fontSize: "1rem",
                          fontWeight: 600,
                          mb: 1,
                          fontFamily: "Poppins",
                        }}
                      >
                        {experience.subtitle || experience.company}
                      </Typography>
                    )}

                    {/* Description (Responsibilities) */}
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{
                        color: "#424242",
                        fontSize: "0.95rem",
                        lineHeight: 1.6,
                        whiteSpace: "pre-line",
                        fontFamily: "Poppins",
                      }}
                    >
                      {experience.description ||
                        (Array.isArray(experience.responsibilities)
                          ? experience.responsibilities.join(", ")
                          : experience.responsibilities) ||
                        t("applicationTable.noItemsListed", { title: t("applicationTable.responsibility") })}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Certificates Section */}
            <Box
              id="certificates-section"
              sx={{
                mb: 4,
                scrollMarginTop: "64px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <WorkspacePremium fontSize="small" />
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: "#000",
                  }}
                >
                  {t("applicationTable.certificates")}
                </Typography>
              </Box>
              <Box sx={{ pl: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {processLanguages(
                  candidate.extracted_informations?.Certificates
                ).map((certificate, index) => (
                  <Chip
                    key={index}
                    label={certificate}
                    sx={{
                      backgroundColor: "#0017E70D",
                      borderRadius: 2.5,
                      borderColor: colors.primary,
                      color: colors.primary,
                      maxWidth: "100%",
                      "& .MuiChip-label": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontFamily: "Poppins",
                      },
                      "& .MuiChip-icon": {
                        color: colors.primary,
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>
            {/* Quiz Responses Section */}
            {(loadingQuiz || (quizResponses && Object.keys(quizResponses).length > 0)) && (
              <Box
                id="quiz-section"
                sx={{
                  mb: 4,
                  scrollMarginTop: "64px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Checklist fontSize="small" sx={{ color: colors.primary }} />
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                      color: "#000",
                    }}
                  >
                    {t("applicationTable.quizResponses")}
                  </Typography>
                </Box>
                <Box sx={{ pl: 2 }}>
                  {loadingQuiz ? (
                    <Typography sx={{ fontFamily: "Poppins", color: "#666", fontSize: 14 }}>
                      {t("applicationTable.loadingQuizResponses")}
                    </Typography>
                  ) : (
                    Array.isArray(quizResponses) && quizResponses.map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          borderRadius: 2,
                          border: "1px solid #e0e0e0",
                          backgroundColor: "#f9fafb",
                          transition: "transform 0.2s",
                          "&:hover": {
                            transform: "translateX(4px)",
                            borderColor: colors.primary,
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "0.9rem",
                            mb: 1,
                            color: colors.primary,
                            fontFamily: "Poppins",
                          }}
                        >
                          {item.label}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.95rem",
                            color: "#333",
                            fontFamily: "Poppins",
                            lineHeight: 1.5,
                          }}
                        >
                          {Array.isArray(item.response) ? item.response.join(", ") : String(item.response || "")}
                        </Typography>
                      </Box>
                    ))
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </StyledDialogContent>
      </StyledDialog>

      {isEmailHistoryOpen && (
        <EmailHistory
          open={isEmailHistoryOpen}
          onClose={() => setIsEmailHistoryOpen(false)}
          candidateEmail={candidate.extracted_informations?.Email || candidate.candidate?.email || ""}
          recruiterId={getUserIdFromAccessToken()}
        />
      )}
    </>
  );
});

const CandidateCards = ({ candidates, steps, post_id, onCandidatesUpdate, filterOptions, setFilterOptions, onFilterApply, postQuiz }) => {
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  // Ensure candidates is an array for safe operations throughout the component
  const safeCandidates = Array.isArray(candidates) ? candidates : [];

  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
  const { showSnackbar } = useContext(SnackbarContext);

  // Local steps state to manage step additions
  const [localSteps, setLocalSteps] = useState(steps);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const candidatesPerPage = 10;

  // Selection state
  const [selectedCandidates, setSelectedCandidates] = useState(new Set());

  // Post Quiz state (locally managed if prop is null)
  const [localPostQuiz, setLocalPostQuiz] = useState(postQuiz);

  useEffect(() => {
    if (postQuiz) {
      setLocalPostQuiz(postQuiz);
    }
  }, [postQuiz]);

  useEffect(() => {
    const fetchQuiz = async () => {
      if (!localPostQuiz && post_id && apiUrl) {
        try {
          const response = await axios.get(`${apiUrl}posts/post_quiz/${post_id}/`);
          if (response.data && response.data !== -1) {
            setLocalPostQuiz(response.data);
          }
        } catch (error) {
          console.error("Error fetching quiz data:", error);
        }
      }
    };
    fetchQuiz();
  }, [post_id, apiUrl, localPostQuiz]);
  // Dialog states
  const [openNotification, setOpenNotification] = useState(false);
  const [openBlockConfirm, setOpenBlockConfirm] = useState(false);
  const [blockReason, setBlockReason] = useState("");
  const [openStepChange, setOpenStepChange] = useState(false);
  const [selectedStep, setSelectedStep] = useState("");
  const [isChangingStep, setIsChangingStep] = useState(false);

  // New step creation dialog state
  const [newStepDialog, setNewStepDialog] = useState({
    open: false,
    newStepName: "",
  });

  // Edit step dialog state
  const [editStepDialog, setEditStepDialog] = useState({
    open: false,
    stepName: "",
    newStepName: "",
  });

  // Delete step dialog state
  const [deleteStepDialog, setDeleteStepDialog] = useState({
    open: false,
    stepName: "",
  });

  // Full step data with IDs
  const [fullStepData, setFullStepData] = useState([]);

  // Interview/Email states
  const [eventTitle, setEventTitle] = useState("");
  const [eventDate, setEventDate] = useState(dayjs());
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
  const [showTemplateDropdown, setShowTemplateDropdown] = useState(false);
  const [templateSearchValue, setTemplateSearchValue] = useState("");
  const [emailFormData, setEmailFormData] = useState({
    recipient_email: "",
    placeholder_values: {},
  });
  const [emailPlaceholders, setEmailPlaceholders] = useState([]);
  const [renderedEmail, setRenderedEmail] = useState({ subject: "", body: "" });
  const [emailLoading, setEmailLoading] = useState(false);

  const [loadingTemplates, setLoadingTemplates] = useState(false);

  // View Mode State
  const [viewMode, setViewMode] = useState("list");

  // Navigation State - for cross-view navigation
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [activeContactCandidate, setActiveContactCandidate] = useState(null);
  const candidateRefs = useRef({});

  // Local state for candidates to handle immediate updates from Board
  const [localCandidates, setLocalCandidates] = useState([]);

  useEffect(() => {
    setLocalCandidates(candidates || []);
  }, [candidates]);

  // Search State
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCandidates, setFilteredCandidates] = useState(null);
  const safeCandidatesCount = filteredCandidates ? filteredCandidates.length : safeCandidates.length;

  // Handle search and filters
  const handleSearch = () => {
    const query = searchQuery.toLowerCase().trim();

    // Check if we have any active filters
    const hasQuizFilters = filterOptions?.quiz_answers && Object.keys(filterOptions.quiz_answers).length > 0;
    const hasStepFilter = !!filterOptions?.step;
    const hasQuizCheckbox = !!filterOptions?.quiz;

    if (!query && !hasQuizFilters && !hasStepFilter && !hasQuizCheckbox) {
      setFilteredCandidates(null);
      return;
    }

    const filtered = safeCandidates.filter((candidate) => {
      // 1. Name search
      let nameMatch = true;
      if (query) {
        const firstName = candidate.candidate?.first_name?.toLowerCase() || "";
        const lastName = candidate.candidate?.last_name?.toLowerCase() || "";
        const fullName = `${firstName} ${lastName}`.trim();
        const extractedName = candidate.extracted_informations?.Name?.toLowerCase() || "";

        nameMatch = firstName.includes(query) ||
          lastName.includes(query) ||
          fullName.includes(query) ||
          extractedName.includes(query);
      }

      // 2. Step filter
      let stepMatch = true;
      if (hasStepFilter) {
        stepMatch = (candidate.step || candidate.status) === filterOptions.step;
      }

      // 3. Quiz presence filter
      let quizPresenceMatch = true;
      if (hasQuizCheckbox) {
        quizPresenceMatch = !!(candidate.quiz && Object.keys(candidate.quiz).length > 0);
      }

      // 4. Specific Quiz answers filter
      let quizAnswersMatch = true;
      if (hasQuizFilters) {
        const candidateAnswers = candidate.quiz || {};
        const candidateName = candidate.candidate ? `${candidate.candidate.first_name} ${candidate.candidate.last_name}` : candidate.extracted_informations?.Name || "Unknonwn";

        quizAnswersMatch = Object.entries(filterOptions.quiz_answers).every(([qId, filterValue]) => {
          // If no filter for this question, it's a match
          if (filterValue === undefined || filterValue === null || filterValue === '' || (Array.isArray(filterValue) && filterValue.length === 0)) {
            return true;
          }

          let candidateValue = undefined;

          // Handle different quiz structures
          if (Array.isArray(candidateAnswers)) {
            // Structure: [ { question: qId, answer: value }, ... ]
            const response = candidateAnswers.find(r =>
              String(r.question) === String(qId) ||
              String(r.question) === `question_${qId}` ||
              `question_${r.question}` === String(qId)
            );
            candidateValue = response ? response.answer : undefined;
          } else if (typeof candidateAnswers === 'object' && candidateAnswers !== null) {
            // Structure: { qId: value, ... } or { question_qId: value, ... }
            if (candidateAnswers[qId] !== undefined) {
              candidateValue = candidateAnswers[qId];
            } else if (candidateAnswers[`question_${qId}`] !== undefined) {
              candidateValue = candidateAnswers[`question_${qId}`];
            } else if (String(qId).startsWith('question_')) {
              const rawId = String(qId).replace('question_', '');
              candidateValue = candidateAnswers[rawId];
            }
          }

          let isMatch = false;
          if (candidateValue === undefined) {
            isMatch = false;
          } else if (Array.isArray(filterValue)) {
            // Multi-choice filter: any selected filter must match the candidate's answer(s)
            const candidateValues = Array.isArray(candidateValue)
              ? candidateValue.map(v => String(v).toLowerCase())
              : [String(candidateValue).toLowerCase()];

            isMatch = filterValue.some(fv => candidateValues.includes(String(fv).toLowerCase()));
          } else {
            // Single-choice or text filter
            if (Array.isArray(candidateValue)) {
              // If candidate answered with multiple options (checkbox), check if any matches filter
              isMatch = candidateValue.some(cv => String(cv).toLowerCase().includes(String(filterValue).toLowerCase()));
            } else {
              // Case-insensitive partial match for text, exact match for others
              const candStr = String(candidateValue || "").toLowerCase();
              const filterStr = String(filterValue || "").toLowerCase();
              isMatch = candStr.includes(filterStr);
            }
          }

          if (!isMatch) {
            console.log(`❌ Mismatch for ${candidateName}: Question ${qId}, Found: "${candidateValue}", Expected: "${filterValue}"`);
          } else {
            console.log(`✅ Match for ${candidateName}: Question ${qId}, Found: "${candidateValue}", Expected: "${filterValue}"`);
          }

          return isMatch;
        });
      }

      return nameMatch && stepMatch && quizPresenceMatch && quizAnswersMatch;
    });

    setFilteredCandidates(filtered);
    setCurrentPage(1);
  };

  // Automatically apply filters when search query or filter options change
  useEffect(() => {
    handleSearch();
  }, [filterOptions, safeCandidates, searchQuery]);


  // Board Handlers
  const handleBoardUpdateStep = async (
    candidateId,
    newStep,
    status,
    description
  ) => {
    // Optimistic Update: Update local state immediately so UI reflects change when switching views
    setLocalCandidates(prev => prev.map(c =>
      c.id === candidateId ? { ...c, step: newStep } : c
    ));

    try {
      const candidate = candidates.find((c) => c.id === candidateId);
      if (!candidate) return;

      const url =
        candidate.status !== "Application-Imported" &&
          candidate.status !== "Scraping-Email" &&
          candidate.status !== "Application Spontane"
          ? `${apiUrl}authentication/applications/${candidate.id}/update-step/`
          : `${apiUrl}authentication/applicationsscraped/${candidate.id}/update-step/`;

      await axios.patch(
        url,
        { step: newStep },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      // Trigger refresh
      if (onCandidatesUpdate) {
        onCandidatesUpdate();
      }
    } catch (error) {
      console.error("Error updating candidate step:", error);
      showSnackbar("Failed to update candidate step", { severity: "error" });
    }
  };

  const handleBoardCreateStep = async (stepName) => {
    try {
      const userId = getUserIdFromAccessToken();
      if (!userId) return;

      await axios.post(
        `${apiUrl}recruiters/steps/create/`,
        {
          step: stepName,
          post: post_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      showSnackbar(`Step "${stepName}" created successfully`, {
        severity: "success",
      });

      if (onCandidatesUpdate) {
        onCandidatesUpdate();
      }
    } catch (error) {
      console.error("Error creating step:", error);
      showSnackbar("Failed to create step", { severity: "error" });
    }
  };

  const handleBoardDeleteStep = async (stepName) => {
    try {
      // Need to find step ID from fullStepData or fetch it
      const stepData = fullStepData.find((s) => s.title === stepName);
      if (!stepData) {
        // Try to refresh step data or warn
        console.warn("Step data not found for deletion");
        return;
      }

      const userId = getUserIdFromAccessToken();
      await fetch(
        `${apiUrl}recruiters/steps/${stepData.id}/delete/?recruiter=${userId}`,
        {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      showSnackbar(`Step "${stepName}" deleted successfully`, {
        severity: "success",
      });

      if (onCandidatesUpdate) {
        onCandidatesUpdate();
      }
    } catch (error) {
      console.error("Error deleting step:", error);
      showSnackbar("Failed to delete step", { severity: "error" });
    }
  };

  // Navigation Handlers - for cross-view navigation
  const handleCandidateClick = (candidateId) => {
    // Keep the candidate ID so board can scroll to it
    setSelectedCandidateId(candidateId);
    setViewMode("board");
  };

  const handleBoardCardClick = (candidateId) => {
    setSelectedCandidateId(candidateId);
    setCurrentPage(1); // Reset to first page so selected candidate appears at top
    setViewMode("list");
  };

  // Scroll to selected candidate when view changes
  useEffect(() => {
    if (selectedCandidateId && viewMode === "list" && candidateRefs.current[selectedCandidateId]) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        candidateRefs.current[selectedCandidateId]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
    }
  }, [selectedCandidateId, viewMode]);

  // Reset to page 1 when candidates array changes (e.g., after filtering)
  // This must be before any conditional returns to follow React hooks rules
  useEffect(() => {
    setCurrentPage(1);
    setSelectedCandidates(new Set());
  }, [safeCandidates.length]);

  // Update local steps when props change
  useEffect(() => {
    setLocalSteps(steps);
    console.log('steps', steps);
  }, [steps]);

  // Fetch full step data with IDs
  useEffect(() => {
    const fetchSteps = async () => {
      const userId = getUserIdFromAccessToken();
      if (!userId) return;

      try {
        const response = await axios.get(
          `${apiUrl}recruiters/steps/?post=${post_id}`,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        if (Array.isArray(response.data)) {
          const fullData = response.data.map((step) => ({
            id: step.id,
            title: step.step,
          }));
          setFullStepData(fullData);
          console.log('fullData22', fullData);
        }
      } catch (error) {
        console.error("Error fetching full step data:", error);
      }
    };

    fetchSteps();
  }, [apiUrl, localSteps]);

  // Handle page change
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    // Scroll to top of candidates section when page changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Handle selection
  const handleSelectCandidate = (candidateId, isSelected) => {
    setSelectedCandidates((prev) => {
      const newSet = new Set(prev);
      if (isSelected) {
        newSet.add(candidateId);
      } else {
        newSet.delete(candidateId);
      }
      return newSet;
    });
  };

  // Get selected candidate data
  const getSelectedCandidate = () => {
    if (activeContactCandidate) return activeContactCandidate;
    if (selectedCandidates.size !== 1) return null;
    const candidateId = Array.from(selectedCandidates)[0];
    return candidates.find((c) => c.id === candidateId);
  };

  // Handle notification button
  const handleNotificationClick = () => {
    const candidate = getSelectedCandidate();
    if (!candidate) return;

    handleContact(candidate);
  };

  const handleContact = (candidate) => {
    if (!candidate) return;

    // Set the specific candidate for the dialog context without checking their checkbox
    setActiveContactCandidate(candidate);

    // Set initial email data
    setEmailFormData({
      recipient_email: candidate.extracted_informations?.Email || "",
      placeholder_values: {},
    });

    // Fetch email templates
    fetchEmailTemplates();

    setOpenNotification(true);
  };

  // Fetch email templates
  const fetchEmailTemplates = async () => {
    try {
      setLoadingTemplates(true);
      const recruiterId = getUserIdFromAccessToken();
      const response = await axios.get(
        `${apiUrl}recruiters/${recruiterId}/templates/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setEmailTemplates(response.data.results || response.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
      showSnackbar(t("snackbars.failedToLoadTemplates"), {
        severity: "error",
        position: "top-right",
      });
    } finally {
      setLoadingTemplates(false);
    }
  };

  // Handle template selection
  const handleEmailTemplateChange = (event) => {
    const templateId = event.target.value;
    setSelectedTemplateId(templateId);
    const template = emailTemplates.find((t) => t.id === parseInt(templateId));
    setSelectedEmailTemplate(template);

    if (template) {
      const isVisual = !!template.design;
      const placeholders = extractPlaceholders(
        template.subject + " " + (isVisual ? template.design : template.body),
        isVisual
      );
      setEmailPlaceholders(placeholders);

      const candidate = getSelectedCandidate() || (selectedCandidateId ? candidates.find(c => c.id === selectedCandidateId) : null);
      const initialValues = {};

      placeholders.forEach((placeholder) => {
        if (candidate) {
          const extracted = candidate.extracted_informations || {};
          const firstName = candidate.candidate?.first_name || extracted.Name?.split(' ')[0] || "";
          const lastName = candidate.candidate?.last_name || extracted.Name?.split(' ').slice(1).join(' ') || "";

          switch (placeholder.toLowerCase()) {
            case "first_name":
            case "prénom":
              initialValues[placeholder] = firstName;
              break;
            case "last_name":
            case "nom_famille":
              initialValues[placeholder] = lastName;
              break;
            case "nom_complet":
            case "name":
              initialValues[placeholder] = extracted.Name || `${firstName} ${lastName}`.trim();
              break;
            case "company":
            case "entreprise":
              initialValues[placeholder] = ""; // Can be filled if post info available
              break;
            case "position":
            case "poste":
            case "job_title":
              initialValues[placeholder] = extracted.Profil || "";
              break;
            default:
              initialValues[placeholder] = "";
          }
        } else {
          initialValues[placeholder] = "";
        }
      });

      setEmailFormData((prev) => ({
        ...prev,
        placeholder_values: initialValues,
      }));
    }
  };

  // Extract placeholders from template
  const extractPlaceholders = (text, isVisual) => {
    const regex = isVisual ? /{{(.*?)}}/g : /{(.*?)}/g;
    const matches = [];
    let match;
    while ((match = regex.exec(text)) !== null) {
      if (!matches.includes(match[1])) {
        matches.push(match[1]);
      }
    }
    return matches;
  };

  // Handle placeholder changes
  const handleEmailPlaceholderChange = (placeholder, value) => {
    setEmailFormData((prev) => ({
      ...prev,
      placeholder_values: {
        ...prev.placeholder_values,
        [placeholder]: value,
      },
    }));
  };

  // Handle email form changes
  const handleEmailFormChange = (e) => {
    const { name, value } = e.target;
    setEmailFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Send email and create event
  const handleSendEmail = async () => {
    const candidate = getSelectedCandidate();
    if (!candidate) return;

    const isImported =
      candidate.status === "Application-Imported" ||
      candidate.status === "Application Spontane" ||
      candidate.status === "Scraping-Email";

    // Validation
    if (isImported && !selectedTemplateId) {
      showSnackbar("Veuillez sélectionner un modèle d'email", {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    if (!isImported && !eventTitle.trim()) {
      showSnackbar("Veuillez entrer un titre pour l'événement", {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    setEmailLoading(true);

    try {
      const recruiterId = getUserIdFromAccessToken();

      // 1. Create Event for Actual Users
      if (!isImported) {
        const eventPayload = {
          event_title: eventTitle,
          event_start_date: eventDate.format("YYYY-MM-DD HH:mm:ss"),
          candidate_id: candidate.candidate?.id || candidate.candidateId,
          recruiter: recruiterId,
        };

        await axios.post(
          `${apiUrl}authentication/events/`,
          eventPayload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
      }

      // 2. Send Email if template selected
      if (selectedTemplateId) {
        const emailPayload = {
          template_id: selectedTemplateId,
          recipient_email: emailFormData.recipient_email,
          placeholder_values: emailFormData.placeholder_values,
          is_visual_template: !!selectedEmailTemplate?.design,
        };

        await axios.post(`${apiUrl}recruiters/${recruiterId}/send-email/`, emailPayload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
      }

      showSnackbar(
        isImported ? "Email envoyé avec succès" : "Entretien planifié avec succès",
        {
          severity: "success",
          position: "top-right",
        }
      );

      handleCloseNotification();
    } catch (error) {
      console.error("Error in contact process:", error);
      showSnackbar("Une erreur est survenue", {
        severity: "error",
        position: "top-right",
      });
    } finally {
      setEmailLoading(false);
    }
  };

  // Close notification dialog
  const handleCloseNotification = () => {
    setOpenNotification(false);
    setSelectedTemplateId("");
    setSelectedEmailTemplate(null);
    setEmailPlaceholders([]);
    setRenderedEmail({ subject: "", body: "" });
    setEventTitle("");
    setActiveContactCandidate(null);
  };
  // Update rendered email when template or placeholders change
  useEffect(() => {
    if (selectedEmailTemplate && emailFormData.placeholder_values) {
      let renderedSubject = selectedEmailTemplate.subject;
      let renderedBody =
        selectedEmailTemplate.design || selectedEmailTemplate.body;
      const isVisual = !!selectedEmailTemplate.design;

      Object.entries(emailFormData.placeholder_values).forEach(
        ([key, value]) => {
          const placeholder = isVisual ? `{{${key}}}` : `{${key}}`;
          const regex = new RegExp(
            placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
            "g"
          );
          renderedSubject = renderedSubject.replace(
            regex,
            value || placeholder
          );
          renderedBody = renderedBody.replace(regex, value || placeholder);
        }
      );

      setRenderedEmail({ subject: renderedSubject, body: renderedBody });
    }
  }, [selectedEmailTemplate, emailFormData.placeholder_values]);

  // Handle block button
  const handleBlockClick = () => {
    // Determine target candidates
    let candidatesToProcess = [];
    if (activeContactCandidate) {
      candidatesToProcess = [activeContactCandidate];
    } else {
      const selectedIds = Array.from(selectedCandidates);
      candidatesToProcess = candidates.filter(c => selectedIds.includes(c.id));
    }

    if (candidatesToProcess.length === 0) {
      showSnackbar("Veuillez sélectionner au moins un candidat à bloquer.", {
        severity: "warning",
      });
      return;
    }

    // Filter out candidates that cannot be blocked
    const invalidCandidates = candidatesToProcess.filter(candidate =>
      candidate.status === "Application-Imported" ||
      candidate.status === "Application Spontane" ||
      candidate.status === "Scraping-Email"
    );

    if (invalidCandidates.length > 0) {
      if (candidatesToProcess.length === 1) {
        showSnackbar(
          "Ce candidat n'est pas un utilisateur, vous ne pouvez pas le bloquer de l'application.",
          {
            severity: "warning",
            position: "top-right",
          }
        );
        return;
      } else if (invalidCandidates.length === candidatesToProcess.length) {
        showSnackbar(
          "Aucun des candidats sélectionnés n'est un utilisateur enregistrée. Ils ne peuvent pas être bloqués.",
          {
            severity: "warning",
            position: "top-right",
          }
        );
        return;
      } else {
        showSnackbar(
          "Certains candidats sélectionnés sont importés et ne peuvent pas être bloqués. Seuls les candidats enregistrés seront traités.",
          {
            severity: "info",
            position: "top-right",
          }
        );
      }
    }

    setOpenBlockConfirm(true);
  };

  // Handle block confirmation
  const handleConfirmBlock = async () => {
    if (!blockReason.trim()) return;

    // Determine target candidates
    let candidatesToProcess = [];
    if (activeContactCandidate) {
      candidatesToProcess = [activeContactCandidate];
    } else {
      const selectedIds = Array.from(selectedCandidates);
      candidatesToProcess = candidates.filter(c => selectedIds.includes(c.id));
    }

    const validCandidates = candidatesToProcess.filter(candidate =>
      candidate.status !== "Application-Imported" &&
      candidate.status !== "Application Spontane" &&
      candidate.status !== "Scraping-Email"
    );

    if (validCandidates.length === 0) return;

    try {
      const recruiterId = getUserIdFromAccessToken();
      let successCount = 0;
      let errorCount = 0;

      // Process in parallel with Promise.allSettled to handle partial failures
      const results = await Promise.allSettled(
        validCandidates.map(candidate => {
          const candidateId = candidate.candidate?.id || candidate.candidateId;
          return axios.post(
            `${apiUrl}recruiters/${recruiterId}/blacklist/`,
            {
              candidate_id: candidateId,
              reason: blockReason,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
            }
          );
        })
      );

      results.forEach(result => {
        if (result.status === 'fulfilled') successCount++;
        else errorCount++;
      });

      if (successCount > 0) {
        showSnackbar(`${successCount} candidat(s) bloqué(s) avec succès.`, {
          severity: "success",
          position: "top-right",
        });
      }

      if (errorCount > 0) {
        showSnackbar(`${errorCount} erreur(s) lors du blocage.`, {
          severity: "error",
          position: "top-right",
        });
      }

      setOpenBlockConfirm(false);
      setBlockReason("");
      setSelectedCandidates(new Set());

      // Trigger refresh
      if (onCandidatesUpdate) {
        onCandidatesUpdate();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error in batch block process:", error);
      showSnackbar("Une erreur est survenue lors du processus.", {
        severity: "error",
        position: "top-right",
      });
    }
  };

  // Handle batch step change with email notification
  const handleBatchStepChange = async () => {
    if (!selectedStep || selectedCandidates.size === 0) return;

    setIsChangingStep(true);
    const selectedIds = Array.from(selectedCandidates);
    const selectedCandidatesData = candidates.filter((c) =>
      selectedIds.includes(c.id)
    );

    try {
      const updatePromises = selectedCandidatesData.map(async (candidate) => {
        const url =
          candidate.status !== "Application-Imported" &&
            candidate.status !== "Scraping-Email" &&
            candidate.status !== "Application Spontane"
            ? `${apiUrl}authentication/applications/${candidate.id}/update-step/`
            : `${apiUrl}authentication/applicationsscraped/${candidate.id}/update-step/`;

        const response = await axios.patch(
          url,
          { step: selectedStep },
          {
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        // Send email notification for each candidate
        if (response.status === 200) {
          const candidateEmail = candidate.status !== "Application-Imported" &&
            candidate.status !== "Scraping-Email" &&
            candidate.status !== "Application Spontane"
            ? candidate.candidate?.email
            : candidate.extracted_informations?.Email;

          if (candidateEmail) {
            try {
              const emailData = {
                user_id: getUserIdFromAccessToken(),
                to: candidateEmail,
                applicant_name: candidate.status !== "Application-Imported" &&
                  candidate.status !== "Scraping-Email" &&
                  candidate.status !== "Application Spontane"
                  ? `${candidate.candidate?.first_name || ""} ${candidate.candidate?.last_name || ""}`
                  : candidate.extracted_informations?.Name || "Dear Applicant",
                status: selectedStep,
                job_title: post_id ? "Job Position" : "Position",
                job_link: post_id ? `${apiUrlFront}viewjob/${btoa(post_id)}` : "#",
                application_date: new Date().toLocaleString(),
                subject: `Application Status Update - ${selectedStep}`,
              };

              await axios.post(
                `${apiUrl}authentication/api/send-email/`,
                emailData
              );
              console.log(`Email sent to ${candidateEmail}`);
            } catch (emailError) {
              console.error(`Failed to send email to ${candidateEmail}:`, emailError);
              // Continue with other updates even if email fails
            }
          }
        }

        return response;
      });

      await Promise.all(updatePromises);

      showSnackbar(
        `${selectedCandidates.size} candidat(s) mis à jour avec succès vers l'étape: ${selectedStep}`,
        {
          severity: "success",
          position: "top-right",
        }
      );
      setOpenStepChange(false);
      setSelectedStep("");
      setSelectedCandidates(new Set());
      setIsChangingStep(false);

      // Trigger refresh if callback provided
      if (onCandidatesUpdate) {
        onCandidatesUpdate();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating candidates:", error);
      showSnackbar("Échec de la mise à jour de certains candidats", {
        severity: "error",
        position: "top-right",
      });
      setIsChangingStep(false);
    }
  };

  // Handle adding a new step
  const handleAddNewStep = () => {
    const trimmedName = newStepDialog.newStepName.trim();

    if (trimmedName === "") {
      showSnackbar("Le nom de l'étape ne peut pas être vide", {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    if (localSteps.includes(trimmedName)) {
      showSnackbar("Ce nom d'étape existe déjà", {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    try {
      // Call API to create step
      const userId = getUserIdFromAccessToken();
      if (!userId) {
        showSnackbar("Échec de la récupération de l'ID utilisateur", {
          severity: "error",
          position: "top-right",
        });
        return;
      }

      axios.post(
        `${apiUrl}recruiters/steps/create/`,
        {
          step: trimmedName,
          post: post_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      ).then(response => {
        console.log("Step added successfully:", response.data);

        // Update local steps only if the step was successfully added to the database
        if (response.data && response.data.id) {
          const updatedSteps = [...localSteps];

          // Insert before "Hired" if it exists, otherwise add at the end
          const hiredIndex = updatedSteps.indexOf("Hired");
          if (hiredIndex !== -1) {
            updatedSteps.splice(hiredIndex, 0, trimmedName);
          } else {
            updatedSteps.push(trimmedName);
          }

          setLocalSteps(updatedSteps);

          // Show success message
          showSnackbar(`Nouvelle étape "${trimmedName}" créée avec succès`, {
            severity: "success",
            position: "top-right",
          });

          // Set the newly created step as selected
          setSelectedStep(trimmedName);

          // Close the new step dialog
          setNewStepDialog({ open: false, newStepName: "" });

          // Trigger parent refresh to get updated steps
          if (onCandidatesUpdate) {
            onCandidatesUpdate();
          }
        }
      }).catch(error => {
        console.error("Error creating step:", error);
        showSnackbar("Échec de la création de l'étape", {
          severity: "error",
          position: "top-right",
        });
      });
    } catch (error) {
      console.error("Error creating step:", error);
      showSnackbar("Échec de la création de l'étape", {
        severity: "error",
        position: "top-right",
      });
    }
  };

  // Handle editing a step
  const handleEditStep = async () => {
    const trimmedName = editStepDialog.newStepName.trim();
    const oldStepName = editStepDialog.stepName;
    console.log('oldStepName', oldStepName, '-----   trimmedName', trimmedName);

    if (trimmedName === "") {
      showSnackbar("Le nom de l'étape ne peut pas être vide", {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    if (trimmedName === oldStepName) {
      setEditStepDialog({ open: false, stepName: "", newStepName: "" });
      return;
    }

    if (localSteps.includes(trimmedName)) {
      showSnackbar("Ce nom d'étape existe déjà", {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    try {
      const stepToUpdate = fullStepData.find(s => s.title === oldStepName);

      if (!stepToUpdate) {
        showSnackbar("Étape introuvable", {
          severity: "error",
          position: "top-right",
        });
        return;
      }

      const response = await axios.put(
        `${apiUrl}recruiters/steps/${stepToUpdate.id}/update/`,
        { step: trimmedName },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 200) {
        // Update local steps
        const updatedSteps = localSteps.map(s => s === oldStepName ? trimmedName : s);
        setLocalSteps(updatedSteps);

        showSnackbar(`Étape renommée en "${trimmedName}" avec succès`, {
          severity: "success",
          position: "top-right",
        });

        setEditStepDialog({ open: false, stepName: "", newStepName: "" });

        if (onCandidatesUpdate) {
          onCandidatesUpdate();
        }
      }
    } catch (error) {
      console.error("Error updating step:", error);
      showSnackbar(t("snackbars.failedToEditStep"), {
        severity: "error",
        position: "top-right",
      });
    }
  };

  // Handle deleting a step
  const handleDeleteStep = async () => {
    const stepToDelete = deleteStepDialog.stepName;

    if (localSteps.length <= 1) {
      showSnackbar(t("snackbars.cannotDeleteLastStep"), {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    // Check if step has candidates
    const stepHasCandidates = safeCandidates.some(c => c.step === stepToDelete);
    if (stepHasCandidates) {
      showSnackbar(t("snackbars.cannotDeleteStepWithCandidates"), {
        severity: "warning",
        position: "top-right",
      });
      return;
    }

    try {
      const stepData = fullStepData.find(s => s.title === stepToDelete);
      if (!stepData) {
        showSnackbar(t("snackbars.stepNotFound"), {
          severity: "error",
          position: "top-right",
        });
        return;
      }

      const userId = getUserIdFromAccessToken();
      const response = await fetch(
        `${apiUrl}recruiters/steps/${stepData.id}/delete/?recruiter=${userId}`,
        {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.ok) {
        const updatedSteps = localSteps.filter(s => s !== stepToDelete);
        setLocalSteps(updatedSteps);

        showSnackbar(`Étape "${stepToDelete}" supprimée avec succès`, {
          severity: "success",
          position: "top-right",
        });

        setDeleteStepDialog({ open: false, stepName: "" });

        if (onCandidatesUpdate) {
          onCandidatesUpdate();
        }
      }
    } catch (error) {
      console.error("Error deleting step:", error);
      showSnackbar("Échec de la suppression de l'étape", {
        severity: "error",
        position: "top-right",
      });
    }
  };

  const getUserIdFromAccessToken = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return null;
    try {
      const base64Url = accessToken.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload).user_id;
    } catch (error) {
      console.error("Failed to decode token:", error);
      return null;
    }
  };


  if (!Array.isArray(candidates)) {
    console.warn("Candidates prop is not an array:", candidates);
  }

  // Calculate pagination values
  // Calculate pagination values
  // Use localCandidates to ensure we have the latest optimistic updates from the board
  // Create a shallow copy to prevent mutation of the underlying array
  let displayCandidates = [...(filteredCandidates ?? localCandidates)];

  // If a candidate is selected, move it to the top of the list
  if (selectedCandidateId && viewMode === "list") {
    const selectedIndex = displayCandidates.findIndex(c => c.id === selectedCandidateId);
    if (selectedIndex > -1) {
      const selectedCandidate = displayCandidates[selectedIndex];
      displayCandidates.splice(selectedIndex, 1);
      displayCandidates.unshift(selectedCandidate);
    }
  }
  const totalPages = Math.ceil(displayCandidates.length / candidatesPerPage);
  const startIndex = (currentPage - 1) * candidatesPerPage;
  const endIndex = startIndex + candidatesPerPage;
  const currentCandidates = displayCandidates.slice(startIndex, endIndex);

  return (
    <Box
      sx={{
        marginX: viewMode === "board" ? { xs: 0, lg: "-20px" } : { xs: 0, sm: 1, md: 2 },
        px: 0,
        width: viewMode === "board" ? "calc(100% + 40px)" : "100%",
        maxWidth: viewMode === "board" ? "calc(100% + 40px)" : "100%",
      }}
    >
      {/* Search Bar Container - Similar to DynamicFormSearchBar */}
      <Box sx={{ p: 0 }}>
        <Grid container>
          <Grid item md={6} display={{ xs: "none", md: "block" }}>
            {/* Result count on the left */}
            {/* {safeCandidatesCount > 0 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  pl: 2,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "#0017E7",
                    fontWeight: 700,
                    fontSize: "1.25rem",
                    fontFamily: "Poppins",
                  }}
                >
                  {safeCandidatesCount} {t("dynamicFormSearchBar.applicationsFound", "candidatures trouvées")}
                </Typography>
              </Box>
            )} */}
          </Grid>
          <Grid item xs={12} md={6}>
            {/* Search Box Container */}
            <Box
              sx={{
                position: "relative",
                width: "100%",
                mb: 2
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                  backgroundColor: "#fff",
                  width: { xs: "100%", md: "100%" },
                  maxWidth: { xs: "100%", md: 716 },
                  height: { xs: "auto", md: 70 },
                  borderRadius: "20px",
                  border: "1px solid #e0e0e0",
                  padding: { xs: "8px", md: "10px" },
                  gap: { xs: "8px", md: "5px" },
                  alignItems: "center",
                  marginTop: 0,
                  flexDirection: { xs: "column", sm: "row" },
                  mb: 0,
                }}
              >
                {/* Search input */}
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    flex: 1,
                  }}
                >
                  <PostSearchBar
                    variant="outlined"
                    size="small"
                    type="text"
                    placeholder={t("dynamicFormSearchBar.filterByName", "Filtrer par nom")}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    sx={{
                      flex: 1,
                      mr: { xs: 0, sm: 1 },
                      mb: { xs: 1, sm: 0 },
                      width: { xs: "100%", sm: "100%" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img
                            src={searchIcon}
                            height={15}
                            width={15}
                            alt={t("dynamicFormSearchBar.search")}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                {/* Search and Filter Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "row" },
                    width: { xs: "100%", sm: "auto" },
                    justifyContent: { xs: "space-between", sm: "flex-start" },
                    gap: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    sx={{
                      textTransform: "none",
                      fontFamily: "Poppins",
                      width: { xs: "100%", sm: 106 },
                      height: { xs: 45, md: 50 },
                      borderRadius: "11px",
                      p: { xs: "10px", md: "14px 26px" },
                      gap: 10,
                      fontSize: { xs: "0.875rem", md: "1rem" },
                      backgroundColor: "#0017E7",
                      "&:hover": {
                        backgroundColor: "rgba(0, 23, 231, 0.9)",
                      },
                    }}
                  >
                    {t("dynamicFormSearchBar.search", "Rechercher")}
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => setFilterDialogOpen(true)}
                    sx={{
                      border: "1px solid #0017E7",
                      boxShadow: "none",
                      ":hover": {
                        backgroundColor: "#f0f4ff",
                        boxShadow: "0 2px 4px rgba(0, 23, 231, 0.2)",
                      },
                      transition: "all 0.3s ease",
                      borderRadius: "11px",
                      backgroundColor: "#fff",
                      fontFamily: "Poppins",
                      minWidth: "auto",
                      padding: "8px",
                      height: { xs: 45, md: 50 },
                      width: { xs: 50, md: 50 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: { xs: 1, sm: 1 },
                      "& .MuiSvgIcon-root": {
                        width: { xs: "18px", md: "20px" },
                        height: { xs: "18px", md: "20px" },
                        color: "#0017E7",
                      },
                    }}
                  >
                    {/* <Filter /> */}
                    <img src={filterIcon} alt="Filter" />
                  </Button>

                  {/* View Mode Toggle */}
                  <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={(event, newMode) => {
                      if (newMode !== null) {
                        setViewMode(newMode);
                        // Clear selection when manually toggling views
                        setSelectedCandidateId(null);
                      }
                    }}
                    aria-label="view mode"
                    size="small"
                    sx={{
                      height: { xs: 45, md: 50 },
                      borderRadius: "11px",
                      "& .MuiToggleButton-root": {
                        border: "1px solid #0017E7",
                        color: "#0017E7",
                        "&:first-of-type": {
                          borderTopLeftRadius: "11px",
                          borderBottomLeftRadius: "11px",
                        },
                        "&:last-of-type": {
                          borderTopRightRadius: "11px",
                          borderBottomRightRadius: "11px",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#0017E7",
                          color: "#fff",
                          "&:hover": {
                            backgroundColor: "rgba(0, 23, 231, 0.9)",
                          },
                        },
                        "&:hover": {
                          backgroundColor: "#f0f4ff",
                        },
                      },
                    }}
                  >
                    <ToggleButton value="list" aria-label="list view">
                      <ViewListIcon />
                    </ToggleButton>
                    <ToggleButton value="board" aria-label="board view">
                      <ViewKanbanIcon />
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {(!displayCandidates || displayCandidates.length === 0) ? (
        <Box
          sx={{
            textAlign: "center",
            mt: { xs: 2, sm: 3, md: 4 },
            mb: { xs: 2, sm: 3, md: 4 },
            px: { xs: 1, sm: 2, md: 3 },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: { xs: "0.875rem", sm: "1.3rem" },
              mb: { xs: 1, sm: 1.5, md: 2 },
              color: theme.palette.primary.main, // Using theme directly or colors.primary
              fontWeight: 500,
              textAlign: "left"
            }}
          >
            0 candidats existants.
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            }}
          >
            {t("candidates.noCandidatesApplied", "No candidates applied yet")}
          </Typography>
        </Box>
      ) : viewMode === "board" ? (
        <Box sx={{ mt: 2 }}>
          <ControlledBoard
            candidates={displayCandidates}
            steps={localSteps}
            setSteps={setLocalSteps}
            createStep={handleBoardCreateStep}
            deleteSteps={handleBoardDeleteStep}
            onUpdateStep={handleBoardUpdateStep}
            onCardClick={handleBoardCardClick}
            selectedCandidateId={selectedCandidateId}
            post={{ id: post_id }}
          />
        </Box>
      ) : (
        <>
          {/* Action Buttons - Show when candidates are selected */}
          {selectedCandidates.size > 0 && (
            <Box
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                backgroundColor: "white",
                borderRadius: 3,
                border: `1px solid ${colors.primary}`,
                p: 2,
                mb: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    fontWeight: 600,
                    color: colors.primary,
                  }}
                >
                  {selectedCandidates.size} candidat(s) sélectionné(s)
                </Typography>

                {/* Step Change Button - Always enabled */}
                <Button
                  onClick={() => setOpenStepChange(true)}
                  variant="outlined"
                  sx={{
                    borderRadius: "10px",
                    borderColor: colors.primary,
                    color: colors.primary,
                    textTransform: "none",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    px: 2,
                    "&:hover": {
                      borderColor: colors.primary,
                      bgcolor: "rgba(0, 23, 231, 0.05)",
                    },
                  }}
                >
                  Changer l'étape ({selectedCandidates.size})
                </Button>
              </Box>

              <Box sx={{ display: "flex", gap: 1.5 }}>
                <Button
                  onClick={handleNotificationClick}
                  disabled={selectedCandidates.size !== 1}
                  sx={{
                    width: 42,
                    height: 42,
                    minWidth: "unset",
                    borderRadius: "10px",
                    backgroundColor:
                      selectedCandidates.size === 1 ? "#0017E7" : "#cccccc",
                    border:
                      selectedCandidates.size === 1
                        ? "1px solid #0017E7"
                        : "1px solid #cccccc",
                    color: "white",
                    "&:hover": {
                      backgroundColor:
                        selectedCandidates.size === 1 ? "#0017E7" : "#cccccc",
                      opacity: selectedCandidates.size === 1 ? 0.8 : 1,
                    },
                    "&:disabled": {
                      backgroundColor: "#cccccc",
                      cursor: "not-allowed",
                    },
                  }}
                  title="Notification"
                >
                  <img
                    src={ring_icon}
                    alt="Notification"
                    style={{
                      filter:
                        selectedCandidates.size === 1 ? "none" : "grayscale(100%)",
                    }}
                  />
                </Button>

                <Button
                  onClick={handleBlockClick}
                  // disabled={selectedCandidates.size !== 1}
                  sx={{
                    width: 42,
                    height: 42,
                    minWidth: "unset",
                    borderRadius: "10px",
                    backgroundColor: "red",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "red",
                      opacity: 1,
                    },
                    "&:disabled": {
                      backgroundColor: "#cccccc",
                      cursor: "not-allowed",
                    },
                  }}
                  title="Blacklist"
                >
                  <BlockIcon />
                </Button>
              </Box>
            </Box>
          )}
          {/* Page Information */}
          <Typography
            // variant="body1"
            // color="text.secondary"
            sx={{
              fontFamily: "Poppins",
              fontSize: { xs: "0.875rem", sm: "1.3rem" },
              mb: { xs: 1, sm: 1.5, md: 2 },
              color: colors.primary,
              fontFamily: "Poppins",
              fontWeight: 500,
            }}
          >
            {displayCandidates.length} candidats existants.
          </Typography>

          {/* Candidate Cards */}
          <Box
            sx={{
              mb: { xs: 2, sm: 3, md: 4 },
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1, sm: 2, md: 3 },
            }}
          >
            {currentCandidates.map((candidate, index) => (
              <CandidateCard
                key={`${candidate.id || index}-${currentPage}`}
                ref={(el) => (candidateRefs.current[candidate.id] = el)}
                candidate={candidate}
                resume_path={candidate.resume}
                coverLetter={candidate.cover_letter}
                steps={localSteps}
                post_id={post_id}
                isSelected={selectedCandidates.has(candidate.id)}
                onSelect={(isSelected) =>
                  handleSelectCandidate(candidate.id, isSelected)
                }
                onCandidatesUpdate={onCandidatesUpdate}
                onClick={() => handleCandidateClick(candidate.id)}
                isHighlighted={selectedCandidateId === candidate.id}
                onContact={handleContact}
              />
            ))}
          </Box>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: { xs: 2, sm: 3, md: 4 },
                mb: { xs: 2, sm: 3, md: 4 },
                flexDirection: "column",
                gap: { xs: 1, sm: 2 },
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                size={isMobile ? "small" : "medium"}
                showFirstButton={!isMobile}
                showLastButton={!isMobile}
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                  },
                  "& .MuiPaginationItem-page.Mui-selected": {
                    backgroundColor: theme.palette.primary.main,
                    color: "white",
                    "&:hover": {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  },
                }}
              />

              {/* Additional pagination info for mobile */}
              {isMobile && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                  }}
                >
                  {t("candidates.totalCandidates", {
                    count: displayCandidates.length,
                    defaultValue: `${displayCandidates.length} total candidates`,
                  })}
                </Typography>
              )}
            </Box>
          )}

        </>
      )}

      {/* Block Confirmation Dialog */}
      <StyledDialog
        open={openBlockConfirm}
        onClose={() => {
          setOpenBlockConfirm(false);
          setBlockReason("");
        }}
        maxWidth="md"
        fullWidth
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <BlockIcon sx={{ color: "red" }} />
              {t("blockCandidate.title")}
            </Box>
          </DialogTitle>
          <IconButton
            onClick={() => {
              setOpenBlockConfirm(false);
              setBlockReason("");
            }}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <StyledDialogContent>
          <Stack spacing={2} sx={{ p: 3 }}>
            <Typography
              variant="body1"
              paragraph
              sx={{
                mb: 3,
                color: "text.primary",
                fontSize: "1.05rem",
                fontFamily: "Poppins",
              }}
            >
              {activeContactCandidate
                ? t("blockCandidate.warning")
                : selectedCandidates.size > 1
                  ? `Êtes-vous sûr de vouloir bloquer ces ${selectedCandidates.size} candidats ? Ils n'ont plus accès à vos offres.`
                  : t("blockCandidate.warning")
              }
            </Typography>

            <Box
              sx={{
                bgcolor: "background.default",
                p: 2,
                borderRadius: "8px",
                mb: 3,
              }}
            >
              <Typography
                variant="body2"
                component="div"
                color="error.main"
                sx={{ mb: 1, fontFamily: "Poppins" }}
              >
                • {t("blockCandidate.effect1")}
                <br />
                • {t("blockCandidate.effect2")}
                <br />• {t("blockCandidate.effect3")}
              </Typography>
            </Box>

            <Typography
              variant="subtitle1"
              fontWeight="500"
              sx={{ mb: 2, fontFamily: "Poppins" }}
            >
              {t("blockCandidate.provideReason")}
            </Typography>

            <Box
              component="textarea"
              value={blockReason}
              onChange={(e) => setBlockReason(e.target.value)}
              placeholder={t("blockCandidate.reasonPlaceholder")}
              maxLength={500}
              sx={{
                width: "100%",
                minHeight: "100px",
                p: 2,
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                fontFamily: "Poppins",
                fontSize: "1rem",
                resize: "vertical",
                "&:focus": {
                  outline: "none",
                  borderColor: colors.primary,
                },
              }}
            />

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontFamily: "Poppins", textAlign: "right" }}
            >
              {blockReason.length}/500 {t("applicationTable.characters")}
            </Typography>
          </Stack>
        </StyledDialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #D9D9D9" }}>
          <Button
            onClick={() => {
              setOpenBlockConfirm(false);
              setBlockReason("");
            }}
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              color: "#FF0000",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              height: 48,
              border: "1px solid #FF0000",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.05)",
                borderColor: "#FF0000",
              },
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            onClick={handleConfirmBlock}
            disabled={!blockReason.trim()}
            variant="contained"
            sx={{
              backgroundColor: "#FF0000",
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: 12,
              height: 48,
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.8)",
              },
            }}
          >
            {t("blockCandidate.block")}
          </Button>
        </DialogActions>
      </StyledDialog>

      {/* Step Change Dialog */}
      <StyledDialog
        open={openStepChange}
        onClose={() => {
          setOpenStepChange(false);
          setSelectedStep("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            Changer l'étape
          </DialogTitle>
          <IconButton
            onClick={() => {
              setOpenStepChange(false);
              setSelectedStep("");
            }}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <StyledDialogContent>
          <Stack spacing={2} sx={{ p: 3 }}>
            <Typography
              sx={{
                fontFamily: "Poppins",
                mb: 2,
                color: "#000",
                fontSize: 15,
              }}
            >
              Sélectionnez une nouvelle étape pour {selectedCandidates.size}{" "}
              candidat(s) :
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {localSteps && localSteps.length > 0 ? (
                localSteps.map((step, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <Button
                      onClick={() => setSelectedStep(step)}
                      variant={selectedStep === step ? "contained" : "outlined"}
                      sx={{
                        flex: 1,
                        borderRadius: "10px",
                        textTransform: "none",
                        fontFamily: "Poppins",
                        justifyContent: "flex-start",
                        borderColor: colors.primary,
                        color: selectedStep === step ? "white" : colors.primary,
                        bgcolor:
                          selectedStep === step ? colors.primary : "transparent",
                        "&:hover": {
                          borderColor: colors.primary,
                          bgcolor:
                            selectedStep === step
                              ? colors.primary
                              : "rgba(0, 23, 231, 0.05)",
                        },
                      }}
                    >
                      {step === "Application Declined"
                        ? "Candidature refusée"
                        : step === "Application Review"
                          ? "Candidature en analyse"
                          : step === "Hired"
                            ? "Candidature acceptée"
                            : step}
                    </Button>
                    <IconButton
                      size="small"
                      disabled={["Application Declined", "Application Review", "Hired"].includes(step)}
                      onClick={() => setEditStepDialog({ open: true, stepName: step, newStepName: step })}
                      sx={{
                        color: colors.primary,
                        "&:hover": { bgcolor: "rgba(0, 23, 231, 0.05)" },
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      disabled={["Application Declined", "Application Review", "Hired"].includes(step)}
                      onClick={() => setDeleteStepDialog({ open: true, stepName: step })}
                      sx={{
                        color: "#FF0000",
                        "&:hover": { bgcolor: "rgba(255, 0, 0, 0.05)" },
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <Typography
                  sx={{ fontFamily: "Poppins", color: "text.secondary" }}
                >
                  {t("applicationTable.noStepsAvailable")}
                </Typography>
              )}

              {/* Add New Step Button */}
              <Button
                onClick={() => setNewStepDialog({ open: true, newStepName: "" })}
                variant="outlined"
                startIcon={<AddIcon />}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontFamily: "Poppins",
                  justifyContent: "center",
                  borderColor: "#4caf50",
                  color: "#4caf50",
                  borderStyle: "dashed",
                  mt: 1,
                  "&:hover": {
                    borderColor: "#4caf50",
                    bgcolor: "rgba(76, 175, 80, 0.05)",
                    borderStyle: "dashed",
                  },
                }}
              >
                {t("applicationTable.createNewStep")}
              </Button>
            </Box>
          </Stack>
        </StyledDialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #D9D9D9" }}>
          <Button
            onClick={() => {
              setOpenStepChange(false);
              setSelectedStep("");
            }}
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              color: "#FF0000",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              height: 48,
              border: "1px solid #FF0000",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.05)",
                borderColor: "#FF0000",
              },
            }}
            disabled={isChangingStep}
          >
            Annuler
          </Button>
          <Button
            onClick={handleBatchStepChange}
            variant="contained"
            disabled={!selectedStep || isChangingStep}
            sx={{
              backgroundColor: colors.primary,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: 12,
              height: 48,
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(0, 23, 231, 0.9)",
                color: "#fff",
                boxShadow: "none",
                border: "1px solid",
                borderColor: colors.primary,
              },
            }}
          >
            {isChangingStep ? t("applicationTable.updating") : t("applicationTable.confirm")}
          </Button>
        </DialogActions>
      </StyledDialog>

      {/* New Step Creation Dialog */}
      <StyledDialog
        open={newStepDialog.open}
        onClose={() => setNewStepDialog({ open: false, newStepName: "" })}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            {t("applicationTable.createNewStep")}
          </DialogTitle>
          <IconButton
            onClick={() => setNewStepDialog({ open: false, newStepName: "" })}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <StyledDialogContent>
          <Stack spacing={2} sx={{ p: 3 }}>
            <Typography sx={{ fontFamily: "Poppins", mb: 2 }}>
              {t("applicationTable.enterNewStepName")}
            </Typography>
            <TextField
              autoFocus
              fullWidth
              value={newStepDialog.newStepName}
              onChange={(e) =>
                setNewStepDialog({ ...newStepDialog, newStepName: e.target.value })
              }
              placeholder="Ex: Entretien technique, Test pratique..."
              variant="outlined"
              sx={{
                "& .MuiInputBase-root": {
                  fontFamily: "Poppins",
                },
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && newStepDialog.newStepName.trim()) {
                  e.preventDefault();
                  handleAddNewStep();
                }
              }}
            />
          </Stack>
        </StyledDialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #D9D9D9" }}>
          <Button
            onClick={() => setNewStepDialog({ open: false, newStepName: "" })}
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              color: "#FF0000",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              height: 48,
              border: "1px solid #FF0000",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.05)",
                borderColor: "#FF0000",
              },
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            onClick={handleAddNewStep}
            variant="contained"
            disabled={!newStepDialog.newStepName.trim()}
            sx={{
              backgroundColor: colors.primary,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: 12,
              height: 48,
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(0, 23, 231, 0.9)",
                color: "#fff",
                boxShadow: "none",
                border: "1px solid",
                borderColor: colors.primary,
              },
            }}
          >
            {t("applicationTable.confirm")}
          </Button>
        </DialogActions>
      </StyledDialog>

      {/* Edit Step Dialog */}
      <StyledDialog
        open={editStepDialog.open}
        onClose={() => setEditStepDialog({ open: false, stepName: "", newStepName: "" })}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            {t("applicationTable.editStep")}
          </DialogTitle>
          <IconButton
            onClick={() => setEditStepDialog({ open: false, stepName: "", newStepName: "" })}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ py: 3, px: 3 }}>
          <Typography sx={{ fontFamily: "Poppins", mb: 2, color: "#666" }}>
            {t("applicationTable.currentStep")} <strong>{editStepDialog.stepName}</strong>
          </Typography>
          <TextField
            autoFocus
            fullWidth
            label={t("dialogs.newName")}
            value={editStepDialog.newStepName}
            onChange={(e) =>
              setEditStepDialog({ ...editStepDialog, newStepName: e.target.value })
            }
            variant="outlined"
            sx={{
              "& .MuiInputBase-root": {
                fontFamily: "Poppins",
                borderRadius: "10px",
              },
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && editStepDialog.newStepName.trim()) {
                e.preventDefault();
                handleEditStep();
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #D9D9D9" }}>
          <Button
            onClick={() => setEditStepDialog({ open: false, stepName: "", newStepName: "" })}
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              color: "#FF0000",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              height: 48,
              border: "1px solid #FF0000",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.05)",
                borderColor: "#FF0000",
              },
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            onClick={handleEditStep}
            variant="contained"
            disabled={!editStepDialog.newStepName.trim()}
            sx={{
              backgroundColor: colors.primary,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: 12,
              height: 48,
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(0, 23, 231, 0.9)",
                color: "#fff",
                boxShadow: "none",
                border: "1px solid",
                borderColor: colors.primary,
              },
            }}
          >
            Enregistrer
          </Button>
        </DialogActions>
      </StyledDialog>

      {/* Delete Step Dialog */}
      <StyledDialog
        open={deleteStepDialog.open}
        onClose={() => setDeleteStepDialog({ open: false, stepName: "" })}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            {t("applicationTable.deleteStep")}
          </DialogTitle>
          <IconButton
            onClick={() => setDeleteStepDialog({ open: false, stepName: "" })}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <StyledDialogContent>
          <Stack spacing={2} sx={{ p: 3 }}>
            <Typography sx={{ fontFamily: "Poppins", fontSize: 16 }}>
              {t("applicationTable.deleteStepConfirm")} <strong>"{deleteStepDialog.stepName}"</strong> ?
            </Typography>
            <Typography sx={{ fontFamily: "Poppins", fontSize: 14, color: "#666", mt: 2 }}>
              {t("applicationTable.irreversibleAction")}
            </Typography>
          </Stack>
        </StyledDialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #D9D9D9" }}>
          <Button
            onClick={() => setDeleteStepDialog({ open: false, stepName: "" })}
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              color: "#666",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              height: 48,
              border: "1px solid #D9D9D9",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(219, 223, 255, 0.05)",
                borderColor: "#D9D9D9",
              },
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            onClick={handleDeleteStep}
            variant="contained"
            sx={{
              backgroundColor: "#FF0000",
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: 12,
              height: 48,
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.8)",
              },
            }}
          >
            {t("applicationTable.delete")}
          </Button>
        </DialogActions>
      </StyledDialog>

      {/* Notification Dialog */}
      <StyledDialog
        open={openNotification}
        onClose={handleCloseNotification}
        maxWidth="lg"
        fullWidth
      >
        <Box
          sx={{
            width: "100%",
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <DialogTitle
            sx={{
              fontSize: 20,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000",
              p: 0,
            }}
          >
            {getSelectedCandidate()?.status !== "Application-Imported" &&
              getSelectedCandidate()?.status !== "Application Spontane" &&
              getSelectedCandidate()?.status !== "Scraping-Email"
              ? "Planifier un entretien"
              : "Contacter le candidat"}
          </DialogTitle>
          <IconButton
            onClick={handleCloseNotification}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              color: "#000",
              border: "1px solid #D9D9D9",
              "&:hover": {
                color: "#000",
                backgroundColor: "#0084ff08",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <StyledDialogContent>
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              {/* Event Creation Section - Only for registered candidates */}
              {getSelectedCandidate()?.status !== "Application-Imported" &&
                getSelectedCandidate()?.status !== "Application Spontane" &&
                getSelectedCandidate()?.status !== "Scraping-Email" && (
                  <Box
                    sx={{
                      p: 3,
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ mb: 2, fontFamily: "Poppins", fontWeight: 600 }}
                    >
                      {t("applicationTable.createEvent")}
                    </Typography>
                    <Stack spacing={2}>
                      <StyledTextField
                        label={t("dialogs.eventTitle")}
                        fullWidth
                        value={eventTitle}
                        onChange={(e) => setEventTitle(e.target.value)}
                        variant="outlined"
                      />
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          label={t("dialogs.dateTime")}
                          value={eventDate}
                          onChange={(newValue) => setEventDate(newValue)}
                          disablePast
                          renderInput={(params) => (
                            <StyledTextField
                              {...params}
                              fullWidth
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Box>
                )}

              {/* Email Interface Section */}
              <Box
                sx={{
                  p: 3,
                  backgroundColor: "#fff",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ mb: 2, fontFamily: "Poppins", fontWeight: 600 }}
                >
                  {t("applicationTable.sendEmail")}
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {/* Template Selection */}
                  <Box sx={{ position: "relative" }}>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        mb: 1,
                      }}
                    >
                      {t("applicationTable.selectTemplate")}
                    </Typography>
                    <StyledTextField
                      fullWidth
                      value={
                        selectedTemplateId
                          ? emailTemplates.find(
                            (t) => t.id === parseInt(selectedTemplateId)
                          )?.name || ""
                          : ""
                      }
                      onChange={(e) => {
                        setTemplateSearchValue(e.target.value.toLowerCase());
                        setShowTemplateDropdown(true);
                      }}
                      onFocus={() => setShowTemplateDropdown(true)}
                      placeholder={t("applicationTable.chooseTemplate")}
                      disabled={emailLoading || loadingTemplates}
                      InputProps={{
                        endAdornment: selectedTemplateId && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedTemplateId("");
                                setShowTemplateDropdown(false);
                                setTemplateSearchValue("");
                              }}
                            >
                              <Close size={16} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {showTemplateDropdown && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          width: "100%",
                          maxHeight: "200px",
                          overflow: "auto",
                          zIndex: 1000,
                          marginTop: "4px",
                        }}
                      >
                        <MuiList dense>
                          {emailTemplates
                            .filter(
                              (template) =>
                                !templateSearchValue ||
                                template.name
                                  .toLowerCase()
                                  .includes(templateSearchValue)
                            )
                            .map((template) => (
                              <ListItem key={template.id} disablePadding>
                                <ListItemButton
                                  onClick={() => {
                                    setSelectedTemplateId(template.id.toString());
                                    setShowTemplateDropdown(false);
                                    setTemplateSearchValue("");
                                    handleEmailTemplateChange({
                                      target: { value: template.id.toString() },
                                    });
                                  }}
                                >
                                  <ListItemText
                                    primary={template.name}
                                    sx={{
                                      "& .MuiTypography-root": {
                                        fontFamily: "Poppins",
                                      },
                                    }}
                                  />
                                </ListItemButton>
                              </ListItem>
                            ))}
                          {emailTemplates.filter(
                            (template) =>
                              !templateSearchValue ||
                              template.name
                                .toLowerCase()
                                .includes(templateSearchValue)
                          ).length === 0 && (
                              <ListItem>
                                <ListItemText
                                  primary={t("applicationTable.noTemplateFound")}
                                  sx={{
                                    "& .MuiTypography-root": {
                                      fontFamily: "Poppins",
                                    },
                                  }}
                                />
                              </ListItem>
                            )}
                        </MuiList>
                      </Paper>
                    )}
                  </Box>

                  {/* Recipient Email */}
                  <StyledTextField
                    label={t("dialogs.recipientEmail")}
                    name="recipient_email"
                    value={emailFormData.recipient_email}
                    onChange={handleEmailFormChange}
                    fullWidth
                    variant="outlined"
                    disabled={emailLoading}
                  />

                  {/* Placeholder Fields */}
                  {emailPlaceholders.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ fontFamily: "Poppins", fontWeight: 600 }}
                      >
                        {t("applicationTable.templateVariables")}
                      </Typography>
                      {emailPlaceholders.map((placeholder) => (
                        <StyledTextField
                          key={placeholder}
                          label={
                            placeholder.charAt(0).toUpperCase() +
                            placeholder.slice(1).replace("_", " ")
                          }
                          value={
                            emailFormData.placeholder_values[placeholder] || ""
                          }
                          onChange={(e) =>
                            handleEmailPlaceholderChange(
                              placeholder,
                              e.target.value
                            )
                          }
                          margin="normal"
                          variant="outlined"
                          size="small"
                          disabled={emailLoading}
                          sx={{
                            width: "100%",
                            mb: 2,
                          }}
                        />
                      ))}
                    </Box>
                  )}

                  {/* Email Preview */}
                  {selectedEmailTemplate && (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ mb: 1, fontWeight: 600, fontFamily: "Poppins" }}
                      >
                        {t("applicationTable.emailPreview")}
                      </Typography>
                      <Box
                        sx={{
                          p: 1.5,
                          mb: 1,
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e0e0e0",
                          borderRadius: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold", fontFamily: "Poppins" }}
                        >
                          <strong>{t("dialogs.subject")}:</strong> {renderedEmail.subject}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          height: "200px",
                          border: "1px solid #e0e0e0",
                          borderRadius: 1,
                          backgroundColor: "#fff",
                          overflow: "auto",
                          p: 2,
                        }}
                      >
                        {selectedEmailTemplate.design ? (
                          <Box
                            dangerouslySetInnerHTML={{
                              __html: renderedEmail.body,
                            }}
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              whiteSpace: "pre-wrap",
                              fontFamily: "Poppins",
                            }}
                          >
                            {renderedEmail.body}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </StyledDialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #D9D9D9" }}>
          <Button
            onClick={handleCloseNotification}
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              color: "#FF0000",
              borderRadius: "10px",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              height: 48,
              border: "1px solid #FF0000",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(219, 223, 255, 0.9)",
                borderColor: "#FF0000",
              },
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            onClick={handleSendEmail}
            variant="contained"
            disabled={
              emailLoading ||
              (getSelectedCandidate()?.status === "Application-Imported" ||
                getSelectedCandidate()?.status === "Application Spontane" ||
                getSelectedCandidate()?.status === "Scraping-Email"
                ? !selectedTemplateId
                : !eventTitle.trim())
            }
            startIcon={emailLoading ? <CircularProgress size={20} /> : null}
            sx={{
              backgroundColor: colors.primary,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "uppercase",
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: 12,
              height: 48,
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(219, 223, 255, 0.9)",
                color: colors.primary,
                boxShadow: "none",
                border: "1px solid",
                borderColor: colors.primary,
              },
              "&:disabled": {
                backgroundColor: "#ccc",
                color: "#666",
              },
            }}
          >
            {emailLoading
              ? "TRAITEMENT..."
              : getSelectedCandidate()?.status === "Application-Imported" ||
                getSelectedCandidate()?.status === "Application Spontane" ||
                getSelectedCandidate()?.status === "Scraping-Email"
                ? "CONTACTER LE CANDIDAT"
                : selectedTemplateId
                  ? "PLANIFIER & ENVOYER L'EMAIL"
                  : "PLANIFIER L'ENTRETIEN"}
          </Button>
        </DialogActions>
      </StyledDialog>
      <FilterDialog
        open={filterDialogOpen}
        onClose={() => setFilterDialogOpen(false)}
        filters={filterOptions}
        setFilters={setFilterOptions}
        onApply={() => {
          setFilterDialogOpen(false);
          if (onFilterApply) onFilterApply();
        }}
        postQuiz={localPostQuiz}
        steps={steps}
      />
    </Box >
  );
};

export default CandidateCards;
